
import {
	ControlsProps,
	ControlsViewType,
	ControlsYearType,
	ControlsGeoType,
	ControlsStatGroupType,
	ControlsType
} from "./types";

export const DATA_VERSION = "1";

// Pages
export const PAGE_KEYS = [
	"map",
	"interventions",
	"about"
];
// Controls > Types
export const CONTROL_TYPES: ControlsType[] = [
	"view",
	"stat",
	"geo",
	"year",
];
// Controls > Default
export const CONTROLS_DEFAULT: ControlsProps = {
	view: "smoke",
	stat: "wsc",
	geo: "county",
	year: "5avg",
	// Preserves stat values between views
	stats: {
		smoke: "wsc",
		heat: "exd",
		cold: "exd"
	},
	years: {
		smoke: "5avg",
		heat: "20avg",
		cold: "20avg"
	}
};
// Controls > View
export const CONTROLS_VIEW_KEYS: ControlsViewType[] = [
	"smoke",
	"heat",
	"cold"
];
// Controls > Year
export const CONTROLS_YEAR_INDIVIDUAL_KEYS = [
	"2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"
];
export const CONTROLS_YEAR_KEYS: ControlsYearType[] = [
	"20avg",
	"5avg",
	...CONTROLS_YEAR_INDIVIDUAL_KEYS
];
// Controls > Geo
export const CONTROLS_GEO_KEYS: ControlsGeoType[] = [
	"county",
	"tract"
];
// Controls > Stats
export const CONTROLS_STAT_GROUP_KEYS: ControlsStatGroupType[] = [
	"exp",
	"out"
];
// Controls > Stats > Smoke
export const CONTROLS_STAT_SMOKE_GROUPED = {
	exp: [
		"wsc",
		"exd",
	],
	out: [
		"edv",
		"mor",
	],
};
// Controls > Stats > Heat
export const CONTROLS_STAT_HEAT_GROUPED = {
	exp: [
		"exd",
	],
	out: {
		"65": [
			"mor65",
			"tot65",
			"edv65"
		],
		"05": [
			"mor05",
			"tot05",
			"edv05"
		]
	}
};
// Controls > Stats > Cold
export const CONTROLS_STAT_COLD_GROUPED = {
	exp: [
		"exd",
	],
	out: {
		"65": [
			"mor65",
			"tot65",
			"edv65"
		],
		"05": [
			"mor05",
			"tot05",
			"edv05"
		]
	}
};
// Controls > Stats > All
export const CONTROLS_STATS_GROUPED = {
	smoke: CONTROLS_STAT_SMOKE_GROUPED,
	heat: CONTROLS_STAT_HEAT_GROUPED,
	cold: CONTROLS_STAT_COLD_GROUPED,
};
export const CONTROLS_STAT_SMOKE = [
	"wsc",
	"exd",
	"edv",
	"mor",
];
export const CONTROLS_STAT_HEAT = [
	"exd",
	"mor65",
	"tot65",
	"edv65",
	"mor05",
	"tot05",
	"edv05"
];
export const CONTROLS_STAT_COLD = [
	"exd",
	"mor65",
	"tot65",
	"edv65",
	"mor05",
	"tot05",
	"edv05"
];
export const CONTROLS_STATS = {
	smoke: CONTROLS_STAT_SMOKE,
	heat: CONTROLS_STAT_HEAT,
	cold: CONTROLS_STAT_COLD
};
// Controls > Stats > Yearly
export const CONTROLS_YEARLY_STAT_KEYS = [
	"wsc",
	"exd"
];
// Controls > Stats > Years
export const CONTROLS_STAT_YEARS = {
	smoke_wsc: ["5avg", ...CONTROLS_YEAR_INDIVIDUAL_KEYS],
	smoke_exd: ["5avg", ...CONTROLS_YEAR_INDIVIDUAL_KEYS],
	smoke_mor: ["5avg", ...CONTROLS_YEAR_INDIVIDUAL_KEYS],
	smoke_edv: ["5avg", ...CONTROLS_YEAR_INDIVIDUAL_KEYS],
	heat_exd: [
		"20avg",
		// "50"
	],
	heat_mor65: ["20avg"],
	heat_mor05: ["20avg"],
	heat_tot65: ["20avg"],
	heat_tot05: ["20avg"],
	heat_edv65: ["20avg"],
	heat_edv05: ["20avg"],
	cold_exd: [
		"20avg",
		// "50"
	],
	cold_mor65: ["20avg"],
	cold_mor05: ["20avg"],
	cold_tot65: ["20avg"],
	cold_tot05: ["20avg"],
	cold_edv65: ["20avg"],
	cold_edv05: ["20avg"],
};
// Controls > By Type
export const CONTROLS_BY_TYPE = {
	view: CONTROLS_VIEW_KEYS,
	stat: CONTROLS_STATS,
	geo: CONTROLS_GEO_KEYS,
	year: CONTROLS_YEAR_KEYS,
};
// Stats
// Stats > Extents
export const STAT_EXTENTS_COUNTY_SMOKE = {
	wsc: [0, 5],
	exd: [0, 50],
	edv: [0, 5],
	mor: [0, 100],
};
export const STAT_EXTENTS_COUNTY_HEAT = {
	exd: [0, 100],
	mor65: [0, 0.05],
	mor05: [0, 0.05],
	tot65: [0, 0.05],
	tot05: [0, 0.05],
	edv65: [0, 0.5],
	edv05: [0, 0.5],
};
export const STAT_EXTENTS_COUNTY_COLD = {
	exd: [0, 200],
	mor66: [0, 0.05],
	mor05: [0, 0.05],
	tot65: [0, 0.05],
	tot05: [0, 0.05],
	edv65: [0, 1],
	edv05: [0, 1],
};
export const STAT_EXTENTS_TRACT_SMOKE = {
	wsc: [0, 10],
	exd: [0, 50],
	mor: [0, 5],
	edv: [0, 0.05],
};
export const STAT_EXTENTS_TRACT_HEAT = {
	exd: [0, 100],
	mor65: [0, 0.05],
	mor05: [0, 0.05],
	tot65: [0, 0.05],
	tot05: [0, 0.05],
	edv65: [0, 0.5],
	edv05: [0, 0.5],
};
export const STAT_EXTENTS_TRACT_COLD = {
	exd: [0, 100],
	mor66: [0, 0.05],
	mor05: [0, 0.05],
	tot65: [0, 0.05],
	tot05: [0, 0.05],
	edv65: [0, 200],
	edv05: [0, 30],
};
export const STAT_EXTENTS = {
	county: {
		smoke: STAT_EXTENTS_COUNTY_SMOKE,
		heat: STAT_EXTENTS_COUNTY_HEAT,
		cold: STAT_EXTENTS_COUNTY_COLD
	},
	tract: {
		smoke: STAT_EXTENTS_TRACT_SMOKE,
		heat: STAT_EXTENTS_TRACT_HEAT,
		cold: STAT_EXTENTS_TRACT_COLD
	}
};
// Stats > Format
export const STAT_UNITS = {
	wsc: "pm",
	exd: "day",
	mor: "per",
	edv: "per",
	mor65: "per",
	mor05: "per",
	tot65: "per",
	tot05: "per",
	edv65: "per",
	edv05: "per",
}
// Stats > California Only
export const STATS_CA_ONLY = [
	"edv",
	"edv65",
	"edv05"
];
// Stats > Ages
export const STAT_AGE_GROUPS = [
	"65",
	"05",
];
// Years > Buckets
export const YEAR_BUCKETS = {
	"1": ["20avg", "5avg"],
	"2": ["2024", "2023"],
	"3": ["2022", "2021"],
	"4": ["2020", "2019"],
	"5": ["2018", "2017"],
	"6": ["2016", "2015"],
	"7": ["2014", "2013"],
	"8": ["2012", "2011"],
	"9": ["2010", "2009"],
	"10": ["2008", "2007", "2006"],
};
// Locations
// Locations > IDs
export const LOCATION_ID_LENGTHS = {
	county: 5,
	tract: 11
}
// Search
export const SEARCH_VERSION = 1;
export const SEARCH_PARAM_KEY = "query";
export const SEARCH_MIN_QUERY = 3;
// Lang
export const LANG = {
	// Site
	site_title: "Environmental Hazard Adaptation Atlas",
	site_description: "Studying the impacts of environmental change on human health and well-being",
	site_stanford_title: "Stanford",
	site_stanford_title_full: "Stanford University",
	site_echo_title: "ECHO Lab",
	site_echo_title_full: "Environmental Change and Human Outcomes Lab",
	// Pages
	page_map: "Map",
	page_interventions: "Interventions",
	page_about: "About",
	// Interventions
	interventions_title: "Interventions for {view}",
	interventions_view_smoke: "Smoke",
	interventions_view_heat: "Heat",
	interventions_view_cold: "Cold",
	interventions_group_exp: "Changes in realized exposure",
	interventions_group_out: "Health outcomes",
	interventions_evidence: "Evidence",
	interventions_evidence_weak: "Weak",
	interventions_evidence_strong: "Strong",
	interventions_outcome: "Outcome",
	interventions_outcome_worse: "Worse",
	interventions_outcome_mixed: "Mixed",
	interventions_outcome_better: "Better",
	interventions_exp_effect_none: "There is no evidence of changes in realized exposure",
	interventions_exp_effect_worse_weak: "There is weak evidence of worse changes in realized exposure",
	interventions_exp_effect_mixed_weak: "There is weak evidence of mixed changes in realized exposure",
	interventions_exp_effect_better_weak: "There is weak evidence of better changes in realized exposure",
	interventions_exp_effect_worse_strong: "There is strong evidence of worse changes in realized exposure",
	interventions_exp_effect_mixed_strong: "There is strong evidence of mixed changes in realized exposure",
	interventions_exp_effect_better_strong: "There is strong evidence of better changes in realized exposure",
	interventions_out_effect_none: "There is no evidence of health outcomes",
	interventions_out_effect_worse_weak: "There is weak evidence of worse health outcomes",
	interventions_out_effect_mixed_weak: "There is weak evidence of mixed health outcomes",
	interventions_out_effect_better_weak: "There is weak evidence of better health outcomes",
	interventions_out_effect_worse_strong: "There is strong evidence of worse health outcomes",
	interventions_out_effect_mixed_strong: "There is strong evidence of mixed health outcomes",
	interventions_out_effect_better_strong: "There is strong evidence of better health outcomes",
	interventions_panel_smoke: "Effectiveness Against Wildfire Smoke",
	interventions_panel_heat: "Effectiveness Against Extreme Heat",
	interventions_panel_cold: "Effectiveness Against Extreme Cold",
	// Controls
	view_smoke: "Wildfire Smoke",
	view_heat: "Extreme Heat",
	view_cold: "Extreme Cold",
	geo: "Geography",
	geo_county: "County",
	geo_tract: "Census Tract",
	year: "Year(s)",
	year_20avg: "Last 20-year average",
	year_5avg: "Last 5-year average",
	year_20avg_title: "Last 20-Year Average",
	year_5avg_title: "Last 5-Year Average",
	year_20avg_short: "’05-’24 Avg.",
	year_5avg_short: "’20-’24 Avg.",
	year_2024: "2024",
	year_2023: "2023",
	year_2022: "2022",
	year_2021: "2021",
	year_2020: "2020",
	year_2019: "2019",
	year_2018: "2018",
	year_2017: "2017",
	year_2016: "2016",
	year_2015: "2015",
	year_2014: "2014",
	year_2013: "2013",
	year_2012: "2012",
	year_2011: "2011",
	year_2010: "2010",
	year_2009: "2009",
	year_2008: "2008",
	year_2007: "2007",
	year_2006: "2006",
	year_disabled_tooltip: "Not available for the selected metric",
	// Data > Stats
	stat_exp: "Exposures",
	stat_exp_tooltip: "",
	stat_out: "Outcomes",
	stat_out_tooltip: "",
	stat_out_05: "Outcomes For Children <5",
	stat_out_05_tooltip: "",
	stat_out_65: "Outcomes For Seniors 65+",
	stat_out_65_tooltip: "",
	stat_tooltip_footer: "View our methodology on the About page",
	// Data > Ages
	age_05: "Children Under 5",
	age_65: "Seniors 65+",
	// Data > Smoke
	// Data > Smoke > WSC
	smoke_wsc: "Wildfire Smoke Concentrations",
	smoke_wsc_title: "Wildfire Smoke Concentrations",
	smoke_wsc_subtitle: "Annual average of wildfire smoke PM<sub>2.5</sub> concentrations",
	smoke_wsc_tooltip: "Annual average of wildfire-derived smoke concentrations of small particulate matter (PM<sub>2.5</sub>). Data are derived from a combination of satellites and ground monitors.",
	// Data > Smoke > EXD
	smoke_exd: "Extreme Smoke Days",
	smoke_exd_title: "Extreme Smoke Days",
	smoke_exd_subtitle: "Annual number of days with wildfire smoke PM<sub>2.5</sub> concentrations ≥ 35µg/m³",
	smoke_exd_tooltip: "Annual number of days with wildfire-derived smoke concentrations of small particulate matter (PM<sub>2.5</sub>) ≥ 35µg/m³. Data are derived from a combination of satellites and ground monitors.",
	// Data > Smoke > MOR
	smoke_mor: "Smoke-Related Mortality",
	smoke_mor_title: "Smoke-Related Mortality",
	smoke_mor_subtitle: "Percent increase in annual mortality from wildfire smoke PM<sub>2.5</sub> exposure",
	smoke_mor_tooltip: "Percent increase in annual mortality from wildfire-derived smoke concentrations of small particulate matter (PM<sub>2.5</sub>) exposure in that year. Estimates are derived from a statistical model that relates local mortality in each year to local smoke exposure, using data on all deaths in the continental U.S.",
	// Data > Smoke > EDV
	smoke_edv: "Smoke-Induced Asthma",
	smoke_edv_title: "Smoke-Induced Asthma",
	smoke_edv_subtitle: "Percent increase in daily emergency department visits for wildfire smoke-induced asthma, on the worst smoke day in that year",
	smoke_edv_tooltip: "Percent increase in daily emergency department visits for wildfire-derived smoke-induced asthma, on the worst smoke day in that year. Estimates are derived from a statistical model that relates daily local asthma emergency department visits to local smoke exposure, using data on all emergency department visits in the state. Currently only available for California.",
	// Data > Heat
	// Data > Heat > EXD
	heat_exd: "Extreme Heat Days",
	heat_exd_title: "Extreme Heat Days",
	heat_exd_subtitle: "Annual count of days with a maximum temperature of 35°C (95°F) or hotter",
	heat_exd_tooltip: "Annual count of days with a maximum temperature of 35°C (95°F) or hotter. Data represents temperatures experienced by a typical person within this {geo}.",
	// Data > Heat > MOR65
	heat_mor: "Mortality on Hot Days",
	heat_mor65: "Mortality on Hot Days",
	heat_mor65_title: "Mortality on Hot Days, Seniors Age 65+",
	heat_mor65_subtitle: "Percent increase in deaths on a day with a maximum temperature of 35°C (95°F) or hotter for individuals 65 or older",
	heat_mor65_tooltip: "Percent increase in deaths on a day with a maximum temperature of 35°C (95°F) or hotter, relative to a day with moderate temperature, for individuals 65 or older. Estimates are derived from a statistical model that relates variation in local mortality to local temperature, using data on all deaths in the continental U.S.",
	// Data > Heat > MOR5
	heat_mor05: "Mortality on Hot Days",
	heat_mor05_title: "Mortality on Hot Days, Children Age <5",
	heat_mor05_subtitle: "Percent increase in deaths on a day with a maximum temperature of 35°C (95°F) or hotter for individuals under 5",
	heat_mor05_tooltip: "Percent increase in deaths on a day with a maximum temperature of 35°C (95°F) or hotter, relative to a day with moderate temperature, for individuals under 5. Estimates are derived from a statistical model that relates variation in local mortality to local temperature, using data on all deaths in the continental U.S.",
	// Data > Heat > TOT65
	heat_tot: "Total Deaths Due to Heat",
	heat_tot65: "Total Deaths Due to Heat",
	heat_tot65_title: "Total Deaths Due to Heat, Seniors Age 65+",
	heat_tot65_subtitle: "Percent of overall deaths due to heat exposure for individuals 65 or older",
	heat_tot65_tooltip: "Percent of annual deaths due to heat exposure for individuals 65 or older.  Calculated by summing excess deaths on days with temperature above moderate temperatures, when mortality is the lowest.",
	// Data > Heat > TOT5
	heat_tot05: "Total Deaths Due to Heat",
	heat_tot05_title: "Total Deaths Due to Heat, Children Age <5",
	heat_tot05_subtitle: "Percent of overall deaths due to heat exposure for individuals under 5",
	heat_tot05_tooltip: "Percent of annual deaths due to heat exposure for individuals under 5. Calculated by summing excess deaths on days with temperature above moderate temperatures, when mortality is the lowest.",
	// Data > Heat > EDV
	heat_edv: "Heat-Related ED Visits",
	// Data > Heat > EDV65
	heat_edv65: "Heat-Related ED Visits",
	heat_edv65_title: "Heat-Related Emergency Department Visits, Seniors Age 65+",
	heat_edv65_subtitle: "Percent increase in emergency department visits on a day with a maximum temperature of 35°C (95°F) or hotter for individuals 65 or older",
	heat_edv65_tooltip: "Percent increase in emergency department visits on days with a maximum temperature of 35°C (95°F) or hotter, relative to a day with moderate temperature, for individuals 65 or older. Currently only available for California.",
	// Data > Heat > EDV05
	heat_edv05: "Heat-Related ED Visits",
	heat_edv05_title: "Heat-Related Emergency Department Visits, Children Age <5",
	heat_edv05_subtitle: "Percent increase in emergency department visits on a day with a maximum temperature of 35°C (95°F) or hotter for individuals under 5",
	heat_edv05_tooltip: "Percent increase in emergency department visits on days with a maximum temperature of 35°C (95°F) or hotter, relative to a day with moderate temperature, for individuals under 5. Currently only available for California.",
	// Data > Cold
	// Data > Cold > EXD
	cold_exd: "Extreme Cold Days",
	cold_exd_title: "Extreme Cold Days",
	cold_exd_subtitle: "Average annual count of days with a minimum temperature of 0°C (32° F) or colder",
	cold_exd_tooltip: "Average annual count of days with a minimum temperature of 0°C (32° F) or colder. Data represents temperatures experienced by a typical person within this {geo}.",
	// Data > Cold > MOR
	cold_mor: "Mortality on Cold Days",
	// Data > Cold > MOR65
	cold_mor65: "Mortality on Cold Days",
	cold_mor65_title: "Mortality on Cold Days, Seniors Age 65+",
	cold_mor65_subtitle: "Percent increase in deaths on a day with a minimum temperature of 0°C (32°F) or colder, for individuals 65 or older",
	cold_mor65_tooltip: "Percent increase in deaths on days with a minimum temperature of 0°C (32°F) or colder, relative to a day with moderate temperature, for individuals 65 or over. Estimates are derived from a statistical model that relates variation in local mortality to local temperature, using data on all deaths in the continental U.S.",
	// Data > Cold > MOR05
	cold_mor05: "Mortality on Cold Days",
	cold_mor05_title: "Mortality on Cold Days, Children Age <5",
	cold_mor05_subtitle: "Percent increase in deaths on a day with a minimum temperature of 0°C (32°F) or colder for individuals under 5",
	cold_mor05_tooltip: "Percent increase in deaths on days with a minimum temperature below 0°C (32°F) or colder, relative to a day with moderate temperature, for individuals under 5. Estimates are derived from a statistical model that relates variation in local mortality to local temperature, using data on all deaths in the continental U.S.",
	// Data > Cold > TOT
	cold_tot: "Total Deaths From Cold",
	// Data > Cold > TOT65
	cold_tot65: "Total Deaths From Cold",
	cold_tot65_title: "Total Deaths Due to Cold, Seniors Age 65+",
	cold_tot65_subtitle: "Percent of overall deaths due to cold exposure for individuals 65 or older",
	cold_tot65_tooltip: "Percent of overall deaths due to cold exposure for individuals 65 or older. Calculated by summing excess deaths on days with temperature below “mortality minimizing” temperature.",
	// Data > Cold > TOT05
	cold_tot05: "Total Deaths From Cold",
	cold_tot05_title: "Total Deaths Due From Cold, Children Age <5",
	cold_tot05_subtitle: "Percent of overall deaths due to cold exposure for individuals under 5",
	cold_tot05_tooltip: "Percent of overall deaths due to cold exposure for individuals under 5. Calculated by summing excess deaths on days with temperature below “mortality minimizing” temperature.",
	// Data > Cold > EDV
	cold_edv: "Cold-Related ED Visits",
	// Data > Cold > EDV65
	cold_edv65: "Cold-Related ED Visits",
	cold_edv65_title: "Cold-Related Emergency Department Visits, Seniors Age 65+",
	cold_edv65_subtitle: "Percent change in emergency department visits on a day with a minimum temperature of 0°C (32°F) or colder for individuals 65 or older",
	cold_edv65_tooltip: "Percent change in emergency department visits on days with a minimum temperature of 0°C (32°F) or colder, relative to a day with moderate temperature, for individuals 65 or older. Currently only available for California.",
	// Data > Cold > EDV05
	cold_edv05: "Cold-Related ED Visits",
	cold_edv05_title: "Cold-Related Emergency Department Visits, Children Age <5",
	cold_edv05_subtitle: "Percent change in emergency department visits on a day with a minimum temperature of 0°C (32°F) or colder, for individuals under 5",
	cold_edv05_tooltip: "Percent change in emergency department visits on days with a minimum temperature of 0°C (32°F) or colder, relative to a day with moderate temperature, for individuals under 5. Currently only available for California.",
	// Data > Stats > Units
	unit_pm: "µg/m³",
	unit_day: "days",
	unit_per: "percent",
	// Map
	map_title: "{stat}, by {geo}, {year}",
	map_title_yearly: "{stat} by {geo} in {year}",
	map_controls_fit: "Fit map to U.S.",
	map_controls_me: "Zoom to my location",
	map_controls_in: "Zoom in on map",
	map_controls_out: "Zoom out on map",
	map_tooltip_footer: "Click for more data",
	// Controls
	controls_toggle_show: "Show Map Options",
	controls_toggle_hide: "Hide Map Options",
	// Profile
	profile_download: "Download PDF",
	profile_copy: "Copy Link",
	profile_copy_tooltip: "Copied link!",
	profile_missing: "This data is currently only available for California",
	profile_pctl_county: "National Percentile",
	profile_pctl_county_tooltip: "County percentile among all counties nationwide. This county has a higher value for this outcome than {pctl}% of other counties.",
	profile_pctl_tract: "State Percentile",
	profile_pctl_tract_tooltip: "Census tract percentile among tracts in the same state. This tract has a higher value for this outcome than {pctl}% of other tracts in the state.",
	profile_smoke_county: "Annual county-level wildfire smoke and its effect on health outcomes in this county over time—for more information about our methods, see the About page",
	profile_smoke_tract: "Annual census tract-level wildfire smoke and its effect on health outcomes in this tract over time—for more information about our methods, see the About page",
	profile_heat_county: "County-level extreme heat exposure, its effect on the health of seniors and young children in this county, and how this compares to other counties in the U.S.—for more information about our methods, see the About page",
	profile_heat_tract: "Census tract-level extreme heat exposure, its effect on the health of seniors and young children in this tract, and how this compares to other tracts in the same state—for more information about our methods, see the About page",
	profile_cold_county: "County-level extreme cold exposure, its effect on the health of seniors and young children in this county, and how this compares to other counties in the U.S.—for more information about our methods, see the About page",
	profile_cold_tract: "Census tract-level extreme cold exposure, its effect on the health of seniors and young children in this tract, and how this compares to other tracts in the same state—for more information about our methods, see the About page",
	// Search
	search_placeholder: "Zoom to a location",
	search_label: "Search for a location on the map",
	search_message_chars: "\"{query}\" is {chars} characters too short",
	search_message_wait: "Searching for \"{query}\"...",
	search_message_empty: "No results for \"{query}\"",
	search_message_show: "Showing results for \"{query}\"",
	// Locations
	// Locations > States
	state_01: "Alabama",
	state_02: "Alaska",
	state_04: "Arizona",
	state_05: "Arkansas",
	state_06: "California",
	state_08: "Colorado",
	state_09: "Connecticut",
	state_10: "Delaware",
	state_11: "District of Columbia",
	state_12: "Florida",
	state_13: "Georgia",
	state_15: "Hawaii",
	state_16: "Idaho",
	state_17: "Illinois",
	state_18: "Indiana",
	state_19: "Iowa",
	state_20: "Kansas",
	state_21: "Kentucky",
	state_22: "Louisiana",
	state_23: "Maine",
	state_24: "Maryland",
	state_25: "Massachusetts",
	state_26: "Michigan",
	state_27: "Minnesota",
	state_28: "Mississippi",
	state_29: "Missouri",
	state_30: "Montana",
	state_31: "Nebraska",
	state_32: "Nevada",
	state_33: "New Hampshire",
	state_34: "New Jersey",
	state_35: "New Mexico",
	state_36: "New York",
	state_37: "North Carolina",
	state_38: "North Dakota",
	state_39: "Ohio",
	state_40: "Oklahoma",
	state_41: "Oregon",
	state_42: "Pennsylvania",
	state_44: "Rhode Island",
	state_45: "South Carolina",
	state_46: "South Dakota",
	state_47: "Tennessee",
	state_48: "Texas",
	state_49: "Utah",
	state_50: "Vermont",
	state_51: "Virginia",
	state_53: "Washington",
	state_54: "West Virginia",
	state_55: "Wisconsin",
	state_56: "Wyoming",
	// Locations > States > Short
	state_01_short: "AL",
	state_02_short: "AK",
	state_04_short: "AZ",
	state_05_short: "AR",
	state_06_short: "CA",
	state_08_short: "CO",
	state_09_short: "CT",
	state_10_short: "DE",
	state_11_short: "DC",
	state_12_short: "FL",
	state_13_short: "GA",
	state_15_short: "HI",
	state_16_short: "ID",
	state_17_short: "IL",
	state_18_short: "IN",
	state_19_short: "IA",
	state_20_short: "KS",
	state_21_short: "KY",
	state_22_short: "LA",
	state_23_short: "ME",
	state_24_short: "MD",
	state_25_short: "MA",
	state_26_short: "MI",
	state_27_short: "MN",
	state_28_short: "MS",
	state_29_short: "MO",
	state_30_short: "MT",
	state_31_short: "NE",
	state_32_short: "NV",
	state_33_short: "NH",
	state_34_short: "NJ",
	state_35_short: "NM",
	state_36_short: "NY",
	state_37_short: "NC",
	state_38_short: "ND",
	state_39_short: "OH",
	state_40_short: "OK",
	state_41_short: "OR",
	state_42_short: "PA",
	state_44_short: "RI",
	state_45_short: "SC",
	state_46_short: "SD",
	state_47_short: "TN",
	state_48_short: "TX",
	state_49_short: "UT",
	state_50_short: "VT",
	state_51_short: "VA",
	state_53_short: "WA",
	state_54_short: "WV",
	state_55_short: "WI",
	state_56_short: "WY",
	// Locations > Counties
	county_01001: "Autauga County",
	county_01003: "Baldwin County",
	county_01005: "Barbour County",
	county_01007: "Bibb County",
	county_01009: "Blount County",
	county_01011: "Bullock County",
	county_01013: "Butler County",
	county_01015: "Calhoun County",
	county_01017: "Chambers County",
	county_01019: "Cherokee County",
	county_01021: "Chilton County",
	county_01023: "Choctaw County",
	county_01025: "Clarke County",
	county_01027: "Clay County",
	county_01029: "Cleburne County",
	county_01031: "Coffee County",
	county_01033: "Colbert County",
	county_01035: "Conecuh County",
	county_01037: "Coosa County",
	county_01039: "Covington County",
	county_01041: "Crenshaw County",
	county_01043: "Cullman County",
	county_01045: "Dale County",
	county_01047: "Dallas County",
	county_01049: "DeKalb County",
	county_01051: "Elmore County",
	county_01053: "Escambia County",
	county_01055: "Etowah County",
	county_01057: "Fayette County",
	county_01059: "Franklin County",
	county_01061: "Geneva County",
	county_01063: "Greene County",
	county_01065: "Hale County",
	county_01067: "Henry County",
	county_01069: "Houston County",
	county_01071: "Jackson County",
	county_01073: "Jefferson County",
	county_01075: "Lamar County",
	county_01077: "Lauderdale County",
	county_01079: "Lawrence County",
	county_01081: "Lee County",
	county_01083: "Limestone County",
	county_01085: "Lowndes County",
	county_01087: "Macon County",
	county_01089: "Madison County",
	county_01091: "Marengo County",
	county_01093: "Marion County",
	county_01095: "Marshall County",
	county_01097: "Mobile County",
	county_01099: "Monroe County",
	county_01101: "Montgomery County",
	county_01103: "Morgan County",
	county_01105: "Perry County",
	county_01107: "Pickens County",
	county_01109: "Pike County",
	county_01111: "Randolph County",
	county_01113: "Russell County",
	county_01115: "St. Clair County",
	county_01117: "Shelby County",
	county_01119: "Sumter County",
	county_01121: "Talladega County",
	county_01123: "Tallapoosa County",
	county_01125: "Tuscaloosa County",
	county_01127: "Walker County",
	county_01129: "Washington County",
	county_01131: "Wilcox County",
	county_01133: "Winston County",
	county_04001: "Apache County",
	county_04003: "Cochise County",
	county_04005: "Coconino County",
	county_04007: "Gila County",
	county_04009: "Graham County",
	county_04011: "Greenlee County",
	county_04012: "La Paz-Yuma Counties",
	county_04013: "Maricopa County",
	county_04015: "Mohave County",
	county_04017: "Navajo County",
	county_04019: "Pima County",
	county_04021: "Pinal County",
	county_04023: "Santa Cruz County",
	county_04025: "Yavapai County",
	county_05001: "Arkansas County",
	county_05003: "Ashley County",
	county_05005: "Baxter County",
	county_05007: "Benton County",
	county_05009: "Boone County",
	county_05011: "Bradley County",
	county_05013: "Calhoun County",
	county_05015: "Carroll County",
	county_05017: "Chicot County",
	county_05019: "Clark County",
	county_05021: "Clay County",
	county_05023: "Cleburne County",
	county_05025: "Cleveland County",
	county_05027: "Columbia County",
	county_05029: "Conway County",
	county_05031: "Craighead County",
	county_05033: "Crawford County",
	county_05035: "Crittenden County",
	county_05037: "Cross County",
	county_05039: "Dallas County",
	county_05041: "Desha County",
	county_05043: "Drew County",
	county_05045: "Faulkner County",
	county_05047: "Franklin County",
	county_05049: "Fulton County",
	county_05051: "Garland County",
	county_05053: "Grant County",
	county_05055: "Greene County",
	county_05057: "Hempstead County",
	county_05059: "Hot Spring County",
	county_05061: "Howard County",
	county_05063: "Independence County",
	county_05065: "Izard County",
	county_05067: "Jackson County",
	county_05069: "Jefferson County",
	county_05071: "Johnson County",
	county_05073: "Lafayette County",
	county_05075: "Lawrence County",
	county_05077: "Lee County",
	county_05079: "Lincoln County",
	county_05081: "Little River County",
	county_05083: "Logan County",
	county_05085: "Lonoke County",
	county_05087: "Madison County",
	county_05089: "Marion County",
	county_05091: "Miller County",
	county_05093: "Mississippi County",
	county_05095: "Monroe County",
	county_05097: "Montgomery County",
	county_05099: "Nevada County",
	county_05101: "Newton County",
	county_05103: "Ouachita County",
	county_05105: "Perry County",
	county_05107: "Phillips County",
	county_05109: "Pike County",
	county_05111: "Poinsett County",
	county_05113: "Polk County",
	county_05115: "Pope County",
	county_05117: "Prairie County",
	county_05119: "Pulaski County",
	county_05121: "Randolph County",
	county_05123: "St. Francis County",
	county_05125: "Saline County",
	county_05127: "Scott County",
	county_05129: "Searcy County",
	county_05131: "Sebastian County",
	county_05133: "Sevier County",
	county_05135: "Sharp County",
	county_05137: "Stone County",
	county_05139: "Union County",
	county_05141: "Van Buren County",
	county_05143: "Washington County",
	county_05145: "White County",
	county_05147: "Woodruff County",
	county_05149: "Yell County",
	county_06001: "Alameda County",
	county_06003: "Alpine County",
	county_06005: "Amador County",
	county_06007: "Butte County",
	county_06009: "Calaveras County",
	county_06011: "Colusa County",
	county_06013: "Contra Costa County",
	county_06015: "Del Norte County",
	county_06017: "El Dorado County",
	county_06019: "Fresno County",
	county_06021: "Glenn County",
	county_06023: "Humboldt County",
	county_06025: "Imperial County",
	county_06027: "Inyo County",
	county_06029: "Kern County",
	county_06031: "Kings County",
	county_06033: "Lake County",
	county_06035: "Lassen County",
	county_06037: "Los Angeles County",
	county_06039: "Madera County",
	county_06041: "Marin County",
	county_06043: "Mariposa County",
	county_06045: "Mendocino County",
	county_06047: "Merced County",
	county_06049: "Modoc County",
	county_06051: "Mono County",
	county_06053: "Monterey County",
	county_06055: "Napa County",
	county_06057: "Nevada County",
	county_06059: "Orange County",
	county_06061: "Placer County",
	county_06063: "Plumas County",
	county_06065: "Riverside County",
	county_06067: "Sacramento County",
	county_06069: "San Benito County",
	county_06071: "San Bernardino County",
	county_06073: "San Diego County",
	county_06075: "San Francisco County",
	county_06077: "San Joaquin County",
	county_06079: "San Luis Obispo County",
	county_06081: "San Mateo County",
	county_06083: "Santa Barbara County",
	county_06085: "Santa Clara County",
	county_06087: "Santa Cruz County",
	county_06089: "Shasta County",
	county_06091: "Sierra County",
	county_06093: "Siskiyou County",
	county_06095: "Solano County",
	county_06097: "Sonoma County",
	county_06099: "Stanislaus County",
	county_06101: "Sutter County",
	county_06103: "Tehama County",
	county_06105: "Trinity County",
	county_06107: "Tulare County",
	county_06109: "Tuolumne County",
	county_06111: "Ventura County",
	county_06113: "Yolo County",
	county_06115: "Yuba County",
	county_08001: "Denver Area Counties",
	county_08003: "Alamosa County",
	county_08007: "Archuleta County",
	county_08009: "Baca County",
	county_08011: "Bent County",
	county_08015: "Chaffee County",
	county_08017: "Cheyenne County",
	county_08019: "Clear Creek County",
	county_08021: "Conejos County",
	county_08023: "Costilla County",
	county_08025: "Crowley County",
	county_08027: "Custer County",
	county_08029: "Delta County",
	county_08033: "Dolores County",
	county_08035: "Douglas County",
	county_08037: "Eagle County",
	county_08039: "Elbert County",
	county_08041: "El Paso County",
	county_08043: "Fremont County",
	county_08045: "Garfield County",
	county_08047: "Gilpin County",
	county_08049: "Grand County",
	county_08051: "Gunnison County",
	county_08053: "Hinsdale County",
	county_08055: "Huerfano County",
	county_08057: "Jackson County",
	county_08061: "Kiowa County",
	county_08063: "Kit Carson County",
	county_08065: "Lake County",
	county_08067: "La Plata County",
	county_08069: "Larimer County",
	county_08071: "Las Animas County",
	county_08073: "Lincoln County",
	county_08075: "Logan County",
	county_08077: "Mesa County",
	county_08079: "Mineral County",
	county_08081: "Moffat County",
	county_08083: "Montezuma County",
	county_08085: "Montrose County",
	county_08087: "Morgan County",
	county_08089: "Otero County",
	county_08091: "Ouray County",
	county_08093: "Park County",
	county_08095: "Phillips County",
	county_08097: "Pitkin County",
	county_08099: "Prowers County",
	county_08101: "Pueblo County",
	county_08103: "Rio Blanco County",
	county_08105: "Rio Grande County",
	county_08107: "Routt County",
	county_08109: "Saguache County",
	county_08111: "San Juan County",
	county_08113: "San Miguel County",
	county_08115: "Sedgwick County",
	county_08117: "Summit County",
	county_08119: "Teller County",
	county_08121: "Washington County",
	county_08125: "Yuma County",
	county_09001: "Fairfield County",
	county_09003: "Hartford County",
	county_09005: "Litchfield County",
	county_09007: "Middlesex County",
	county_09009: "New Haven County",
	county_09011: "New London County",
	county_09013: "Tolland County",
	county_09015: "Windham County",
	county_10001: "Kent County",
	county_10003: "New Castle County",
	county_10005: "Sussex County",
	county_11001: "District of Columbia",
	county_12001: "Alachua County",
	county_12003: "Baker County",
	county_12005: "Bay County",
	county_12007: "Bradford County",
	county_12009: "Brevard County",
	county_12011: "Broward County",
	county_12013: "Calhoun County",
	county_12015: "Charlotte County",
	county_12017: "Citrus County",
	county_12019: "Clay County",
	county_12021: "Collier County",
	county_12023: "Columbia County",
	county_12025: "Miami-Dade County",
	county_12027: "DeSoto County",
	county_12029: "Dixie County",
	county_12031: "Duval County",
	county_12033: "Escambia County",
	county_12035: "Flagler County",
	county_12037: "Franklin County",
	county_12039: "Gadsden County",
	county_12041: "Gilchrist County",
	county_12043: "Glades County",
	county_12045: "Gulf County",
	county_12047: "Hamilton County",
	county_12049: "Hardee County",
	county_12051: "Hendry County",
	county_12053: "Hernando County",
	county_12055: "Highlands County",
	county_12057: "Hillsborough County",
	county_12059: "Holmes County",
	county_12061: "Indian River County",
	county_12063: "Jackson County",
	county_12065: "Jefferson County",
	county_12067: "Lafayette County",
	county_12069: "Lake County",
	county_12071: "Lee County",
	county_12073: "Leon County",
	county_12075: "Levy County",
	county_12077: "Liberty County",
	county_12079: "Madison County",
	county_12081: "Manatee County",
	county_12083: "Marion County",
	county_12085: "Martin County",
	county_12087: "Monroe County",
	county_12089: "Nassau County",
	county_12091: "Okaloosa County",
	county_12093: "Okeechobee County",
	county_12095: "Orange County",
	county_12097: "Osceola County",
	county_12099: "Palm Beach County",
	county_12101: "Pasco County",
	county_12103: "Pinellas County",
	county_12105: "Polk County",
	county_12107: "Putnam County",
	county_12109: "St. Johns County",
	county_12111: "St. Lucie County",
	county_12113: "Santa Rosa County",
	county_12115: "Sarasota County",
	county_12117: "Seminole County",
	county_12119: "Sumter County",
	county_12121: "Suwannee County",
	county_12123: "Taylor County",
	county_12125: "Union County",
	county_12127: "Volusia County",
	county_12129: "Wakulla County",
	county_12131: "Walton County",
	county_12133: "Washington County",
	county_13001: "Appling County",
	county_13003: "Atkinson County",
	county_13005: "Bacon County",
	county_13007: "Baker County",
	county_13009: "Baldwin County",
	county_13011: "Banks County",
	county_13013: "Barrow County",
	county_13015: "Bartow County",
	county_13017: "Ben Hill County",
	county_13019: "Berrien County",
	county_13021: "Bibb County",
	county_13023: "Bleckley County",
	county_13025: "Brantley County",
	county_13027: "Brooks County",
	county_13029: "Bryan County",
	county_13031: "Bulloch County",
	county_13033: "Burke County",
	county_13035: "Butts County",
	county_13037: "Calhoun County",
	county_13039: "Camden County",
	county_13043: "Candler County",
	county_13045: "Carroll County",
	county_13047: "Catoosa County",
	county_13049: "Charlton County",
	county_13051: "Chatham County",
	county_13053: "Chattahoochee County",
	county_13055: "Chattooga County",
	county_13057: "Cherokee County",
	county_13059: "Clarke County",
	county_13061: "Clay County",
	county_13063: "Clayton County",
	county_13065: "Clinch County",
	county_13067: "Cobb County",
	county_13069: "Coffee County",
	county_13071: "Colquitt County",
	county_13073: "Columbia County",
	county_13075: "Cook County",
	county_13077: "Coweta County",
	county_13079: "Crawford County",
	county_13081: "Crisp County",
	county_13083: "Dade County",
	county_13085: "Dawson County",
	county_13087: "Decatur County",
	county_13089: "DeKalb County",
	county_13091: "Dodge County",
	county_13093: "Dooly County",
	county_13095: "Dougherty County",
	county_13097: "Douglas County",
	county_13099: "Early County",
	county_13101: "Echols County",
	county_13103: "Effingham County",
	county_13105: "Elbert County",
	county_13107: "Emanuel County",
	county_13109: "Evans County",
	county_13111: "Fannin County",
	county_13113: "Fayette County",
	county_13115: "Floyd County",
	county_13117: "Forsyth County",
	county_13119: "Franklin County",
	county_13121: "Fulton County",
	county_13123: "Gilmer County",
	county_13125: "Glascock County",
	county_13127: "Glynn County",
	county_13129: "Gordon County",
	county_13131: "Grady County",
	county_13133: "Greene County",
	county_13135: "Gwinnett County",
	county_13137: "Habersham County",
	county_13139: "Hall County",
	county_13141: "Hancock County",
	county_13143: "Haralson County",
	county_13145: "Harris County",
	county_13147: "Hart County",
	county_13149: "Heard County",
	county_13151: "Henry County",
	county_13153: "Houston County",
	county_13155: "Irwin County",
	county_13157: "Jackson County",
	county_13159: "Jasper County",
	county_13161: "Jeff Davis County",
	county_13163: "Jefferson County",
	county_13165: "Jenkins County",
	county_13167: "Johnson County",
	county_13169: "Jones County",
	county_13171: "Lamar County",
	county_13173: "Lanier County",
	county_13175: "Laurens County",
	county_13177: "Lee County",
	county_13179: "Liberty County",
	county_13181: "Lincoln County",
	county_13183: "Long County",
	county_13185: "Lowndes County",
	county_13187: "Lumpkin County",
	county_13189: "McDuffie County",
	county_13191: "McIntosh County",
	county_13193: "Macon County",
	county_13195: "Madison County",
	county_13197: "Marion County",
	county_13199: "Meriwether County",
	county_13201: "Miller County",
	county_13205: "Mitchell County",
	county_13207: "Monroe County",
	county_13209: "Montgomery County",
	county_13211: "Morgan County",
	county_13213: "Murray County",
	county_13215: "Muscogee County",
	county_13217: "Newton County",
	county_13219: "Oconee County",
	county_13221: "Oglethorpe County",
	county_13223: "Paulding County",
	county_13225: "Peach County",
	county_13227: "Pickens County",
	county_13229: "Pierce County",
	county_13231: "Pike County",
	county_13233: "Polk County",
	county_13235: "Pulaski County",
	county_13237: "Putnam County",
	county_13239: "Quitman County",
	county_13241: "Rabun County",
	county_13243: "Randolph County",
	county_13245: "Richmond County",
	county_13247: "Rockdale County",
	county_13249: "Schley County",
	county_13251: "Screven County",
	county_13253: "Seminole County",
	county_13255: "Spalding County",
	county_13257: "Stephens County",
	county_13259: "Stewart County",
	county_13261: "Sumter County",
	county_13263: "Talbot County",
	county_13265: "Taliaferro County",
	county_13267: "Tattnall County",
	county_13269: "Taylor County",
	county_13271: "Telfair County",
	county_13273: "Terrell County",
	county_13275: "Thomas County",
	county_13277: "Tift County",
	county_13279: "Toombs County",
	county_13281: "Towns County",
	county_13283: "Treutlen County",
	county_13285: "Troup County",
	county_13287: "Turner County",
	county_13289: "Twiggs County",
	county_13291: "Union County",
	county_13293: "Upson County",
	county_13295: "Walker County",
	county_13297: "Walton County",
	county_13299: "Ware County",
	county_13301: "Warren County",
	county_13303: "Washington County",
	county_13305: "Wayne County",
	county_13307: "Webster County",
	county_13309: "Wheeler County",
	county_13311: "White County",
	county_13313: "Whitfield County",
	county_13315: "Wilcox County",
	county_13317: "Wilkes County",
	county_13319: "Wilkinson County",
	county_13321: "Worth County",
	county_16001: "Ada County",
	county_16003: "Adams County",
	county_16005: "Bannock County",
	county_16007: "Bear Lake County",
	county_16009: "Benewah County",
	county_16011: "Bingham County",
	county_16013: "Blaine County",
	county_16015: "Boise County",
	county_16017: "Bonner County",
	county_16019: "Bonneville County",
	county_16021: "Boundary County",
	county_16023: "Butte County",
	county_16025: "Camas County",
	county_16027: "Canyon County",
	county_16029: "Caribou County",
	county_16031: "Cassia County",
	county_16033: "Clark County",
	county_16035: "Clearwater County",
	county_16037: "Custer County",
	county_16039: "Elmore County",
	county_16041: "Franklin County",
	county_16043: "Fremont County",
	county_16045: "Gem County",
	county_16047: "Gooding County",
	county_16049: "Idaho County",
	county_16051: "Jefferson County",
	county_16053: "Jerome County",
	county_16055: "Kootenai County",
	county_16057: "Latah County",
	county_16059: "Lemhi County",
	county_16061: "Lewis County",
	county_16063: "Lincoln County",
	county_16065: "Madison County",
	county_16067: "Minidoka County",
	county_16069: "Nez Perce County",
	county_16071: "Oneida County",
	county_16073: "Owyhee County",
	county_16075: "Payette County",
	county_16077: "Power County",
	county_16079: "Shoshone County",
	county_16081: "Teton County",
	county_16083: "Twin Falls County",
	county_16085: "Valley County",
	county_16087: "Washington County",
	county_17001: "Adams County",
	county_17003: "Alexander County",
	county_17005: "Bond County",
	county_17007: "Boone County",
	county_17009: "Brown County",
	county_17011: "Bureau County",
	county_17013: "Calhoun County",
	county_17015: "Carroll County",
	county_17017: "Cass County",
	county_17019: "Champaign County",
	county_17021: "Christian County",
	county_17023: "Clark County",
	county_17025: "Clay County",
	county_17027: "Clinton County",
	county_17029: "Coles County",
	county_17031: "Cook County",
	county_17033: "Crawford County",
	county_17035: "Cumberland County",
	county_17037: "DeKalb County",
	county_17039: "De Witt County",
	county_17041: "Douglas County",
	county_17043: "DuPage County",
	county_17045: "Edgar County",
	county_17047: "Edwards County",
	county_17049: "Effingham County",
	county_17051: "Fayette County",
	county_17053: "Ford County",
	county_17055: "Franklin County",
	county_17057: "Fulton County",
	county_17059: "Gallatin County",
	county_17061: "Greene County",
	county_17063: "Grundy County",
	county_17065: "Hamilton County",
	county_17067: "Hancock County",
	county_17069: "Hardin County",
	county_17071: "Henderson County",
	county_17073: "Henry County",
	county_17075: "Iroquois County",
	county_17077: "Jackson County",
	county_17079: "Jasper County",
	county_17081: "Jefferson County",
	county_17083: "Jersey County",
	county_17085: "Jo Daviess County",
	county_17087: "Johnson County",
	county_17089: "Kane County",
	county_17091: "Kankakee County",
	county_17093: "Kendall County",
	county_17095: "Knox County",
	county_17097: "Lake County",
	county_17099: "LaSalle County",
	county_17101: "Lawrence County",
	county_17103: "Lee County",
	county_17105: "Livingston County",
	county_17107: "Logan County",
	county_17109: "McDonough County",
	county_17111: "McHenry County",
	county_17113: "McLean County",
	county_17115: "Macon County",
	county_17117: "Macoupin County",
	county_17119: "Madison County",
	county_17121: "Marion County",
	county_17123: "Marshall County",
	county_17125: "Mason County",
	county_17127: "Massac County",
	county_17129: "Menard County",
	county_17131: "Mercer County",
	county_17133: "Monroe County",
	county_17135: "Montgomery County",
	county_17137: "Morgan County",
	county_17139: "Moultrie County",
	county_17141: "Ogle County",
	county_17143: "Peoria County",
	county_17145: "Perry County",
	county_17147: "Piatt County",
	county_17149: "Pike County",
	county_17151: "Pope County",
	county_17153: "Pulaski County",
	county_17155: "Putnam County",
	county_17157: "Randolph County",
	county_17159: "Richland County",
	county_17161: "Rock Island County",
	county_17163: "St. Clair County",
	county_17165: "Saline County",
	county_17167: "Sangamon County",
	county_17169: "Schuyler County",
	county_17171: "Scott County",
	county_17173: "Shelby County",
	county_17175: "Stark County",
	county_17177: "Stephenson County",
	county_17179: "Tazewell County",
	county_17181: "Union County",
	county_17183: "Vermilion County",
	county_17185: "Wabash County",
	county_17187: "Warren County",
	county_17189: "Washington County",
	county_17191: "Wayne County",
	county_17193: "White County",
	county_17195: "Whiteside County",
	county_17197: "Will County",
	county_17199: "Williamson County",
	county_17201: "Winnebago County",
	county_17203: "Woodford County",
	county_18001: "Adams County",
	county_18003: "Allen County",
	county_18005: "Bartholomew County",
	county_18007: "Benton County",
	county_18009: "Blackford County",
	county_18011: "Boone County",
	county_18013: "Brown County",
	county_18015: "Carroll County",
	county_18017: "Cass County",
	county_18019: "Clark County",
	county_18021: "Clay County",
	county_18023: "Clinton County",
	county_18025: "Crawford County",
	county_18027: "Daviess County",
	county_18029: "Dearborn County",
	county_18031: "Decatur County",
	county_18033: "DeKalb County",
	county_18035: "Delaware County",
	county_18037: "Dubois County",
	county_18039: "Elkhart County",
	county_18041: "Fayette County",
	county_18043: "Floyd County",
	county_18045: "Fountain County",
	county_18047: "Franklin County",
	county_18049: "Fulton County",
	county_18051: "Gibson County",
	county_18053: "Grant County",
	county_18055: "Greene County",
	county_18057: "Hamilton County",
	county_18059: "Hancock County",
	county_18061: "Harrison County",
	county_18063: "Hendricks County",
	county_18065: "Henry County",
	county_18067: "Howard County",
	county_18069: "Huntington County",
	county_18071: "Jackson County",
	county_18073: "Jasper County",
	county_18075: "Jay County",
	county_18077: "Jefferson County",
	county_18079: "Jennings County",
	county_18081: "Johnson County",
	county_18083: "Knox County",
	county_18085: "Kosciusko County",
	county_18087: "LaGrange County",
	county_18089: "Lake County",
	county_18091: "LaPorte County",
	county_18093: "Lawrence County",
	county_18095: "Madison County",
	county_18097: "Marion County",
	county_18099: "Marshall County",
	county_18101: "Martin County",
	county_18103: "Miami County",
	county_18105: "Monroe County",
	county_18107: "Montgomery County",
	county_18109: "Morgan County",
	county_18111: "Newton County",
	county_18113: "Noble County",
	county_18115: "Ohio County",
	county_18117: "Orange County",
	county_18119: "Owen County",
	county_18121: "Parke County",
	county_18123: "Perry County",
	county_18125: "Pike County",
	county_18127: "Porter County",
	county_18129: "Posey County",
	county_18131: "Pulaski County",
	county_18133: "Putnam County",
	county_18135: "Randolph County",
	county_18137: "Ripley County",
	county_18139: "Rush County",
	county_18141: "St. Joseph County",
	county_18143: "Scott County",
	county_18145: "Shelby County",
	county_18147: "Spencer County",
	county_18149: "Starke County",
	county_18151: "Steuben County",
	county_18153: "Sullivan County",
	county_18155: "Switzerland County",
	county_18157: "Tippecanoe County",
	county_18159: "Tipton County",
	county_18161: "Union County",
	county_18163: "Vanderburgh County",
	county_18165: "Vermillion County",
	county_18167: "Vigo County",
	county_18169: "Wabash County",
	county_18171: "Warren County",
	county_18173: "Warrick County",
	county_18175: "Washington County",
	county_18177: "Wayne County",
	county_18179: "Wells County",
	county_18181: "White County",
	county_18183: "Whitley County",
	county_19001: "Adair County",
	county_19003: "Adams County",
	county_19005: "Allamakee County",
	county_19007: "Appanoose County",
	county_19009: "Audubon County",
	county_19011: "Benton County",
	county_19013: "Black Hawk County",
	county_19015: "Boone County",
	county_19017: "Bremer County",
	county_19019: "Buchanan County",
	county_19021: "Buena Vista County",
	county_19023: "Butler County",
	county_19025: "Calhoun County",
	county_19027: "Carroll County",
	county_19029: "Cass County",
	county_19031: "Cedar County",
	county_19033: "Cerro Gordo County",
	county_19035: "Cherokee County",
	county_19037: "Chickasaw County",
	county_19039: "Clarke County",
	county_19041: "Clay County",
	county_19043: "Clayton County",
	county_19045: "Clinton County",
	county_19047: "Crawford County",
	county_19049: "Dallas County",
	county_19051: "Davis County",
	county_19053: "Decatur County",
	county_19055: "Delaware County",
	county_19057: "Des Moines County",
	county_19059: "Dickinson County",
	county_19061: "Dubuque County",
	county_19063: "Emmet County",
	county_19065: "Fayette County",
	county_19067: "Floyd County",
	county_19069: "Franklin County",
	county_19071: "Fremont County",
	county_19073: "Greene County",
	county_19075: "Grundy County",
	county_19077: "Guthrie County",
	county_19079: "Hamilton County",
	county_19081: "Hancock County",
	county_19083: "Hardin County",
	county_19085: "Harrison County",
	county_19087: "Henry County",
	county_19089: "Howard County",
	county_19091: "Humboldt County",
	county_19093: "Ida County",
	county_19095: "Iowa County",
	county_19097: "Jackson County",
	county_19099: "Jasper County",
	county_19101: "Jefferson County",
	county_19103: "Johnson County",
	county_19105: "Jones County",
	county_19107: "Keokuk County",
	county_19109: "Kossuth County",
	county_19111: "Lee County",
	county_19113: "Linn County",
	county_19115: "Louisa County",
	county_19117: "Lucas County",
	county_19119: "Lyon County",
	county_19121: "Madison County",
	county_19123: "Mahaska County",
	county_19125: "Marion County",
	county_19127: "Marshall County",
	county_19129: "Mills County",
	county_19131: "Mitchell County",
	county_19133: "Monona County",
	county_19135: "Monroe County",
	county_19137: "Montgomery County",
	county_19139: "Muscatine County",
	county_19141: "O'Brien County",
	county_19143: "Osceola County",
	county_19145: "Page County",
	county_19147: "Palo Alto County",
	county_19149: "Plymouth County",
	county_19151: "Pocahontas County",
	county_19153: "Polk County",
	county_19155: "Pottawattamie County",
	county_19157: "Poweshiek County",
	county_19159: "Ringgold County",
	county_19161: "Sac County",
	county_19163: "Scott County",
	county_19165: "Shelby County",
	county_19167: "Sioux County",
	county_19169: "Story County",
	county_19171: "Tama County",
	county_19173: "Taylor County",
	county_19175: "Union County",
	county_19177: "Van Buren County",
	county_19179: "Wapello County",
	county_19181: "Warren County",
	county_19183: "Washington County",
	county_19185: "Wayne County",
	county_19187: "Webster County",
	county_19189: "Winnebago County",
	county_19191: "Winneshiek County",
	county_19193: "Woodbury County",
	county_19195: "Worth County",
	county_19197: "Wright County",
	county_20001: "Allen County",
	county_20003: "Anderson County",
	county_20005: "Atchison County",
	county_20007: "Barber County",
	county_20009: "Barton County",
	county_20011: "Bourbon County",
	county_20013: "Brown County",
	county_20015: "Butler County",
	county_20017: "Chase County",
	county_20019: "Chautauqua County",
	county_20021: "Cherokee County",
	county_20023: "Cheyenne County",
	county_20025: "Clark County",
	county_20027: "Clay County",
	county_20029: "Cloud County",
	county_20031: "Coffey County",
	county_20033: "Comanche County",
	county_20035: "Cowley County",
	county_20037: "Crawford County",
	county_20039: "Decatur County",
	county_20041: "Dickinson County",
	county_20043: "Doniphan County",
	county_20045: "Douglas County",
	county_20047: "Edwards County",
	county_20049: "Elk County",
	county_20051: "Ellis County",
	county_20053: "Ellsworth County",
	county_20055: "Finney County",
	county_20057: "Ford County",
	county_20059: "Franklin County",
	county_20061: "Geary County",
	county_20063: "Gove County",
	county_20065: "Graham County",
	county_20067: "Grant County",
	county_20069: "Gray County",
	county_20071: "Greeley County",
	county_20073: "Greenwood County",
	county_20075: "Hamilton County",
	county_20077: "Harper County",
	county_20079: "Harvey County",
	county_20081: "Haskell County",
	county_20083: "Hodgeman County",
	county_20085: "Jackson County",
	county_20087: "Jefferson County",
	county_20089: "Jewell County",
	county_20091: "Johnson County",
	county_20093: "Kearny County",
	county_20095: "Kingman County",
	county_20097: "Kiowa County",
	county_20099: "Labette County",
	county_20101: "Lane County",
	county_20103: "Leavenworth County",
	county_20105: "Lincoln County",
	county_20107: "Linn County",
	county_20109: "Logan County",
	county_20111: "Lyon County",
	county_20113: "McPherson County",
	county_20115: "Marion County",
	county_20117: "Marshall County",
	county_20119: "Meade County",
	county_20121: "Miami County",
	county_20123: "Mitchell County",
	county_20125: "Montgomery County",
	county_20127: "Morris County",
	county_20129: "Morton County",
	county_20131: "Nemaha County",
	county_20133: "Neosho County",
	county_20135: "Ness County",
	county_20137: "Norton County",
	county_20139: "Osage County",
	county_20141: "Osborne County",
	county_20143: "Ottawa County",
	county_20145: "Pawnee County",
	county_20147: "Phillips County",
	county_20149: "Pottawatomie County",
	county_20151: "Pratt County",
	county_20153: "Rawlins County",
	county_20155: "Reno County",
	county_20157: "Republic County",
	county_20159: "Rice County",
	county_20161: "Riley County",
	county_20163: "Rooks County",
	county_20165: "Rush County",
	county_20167: "Russell County",
	county_20169: "Saline County",
	county_20171: "Scott County",
	county_20173: "Sedgwick County",
	county_20175: "Seward County",
	county_20177: "Shawnee County",
	county_20179: "Sheridan County",
	county_20181: "Sherman County",
	county_20183: "Smith County",
	county_20185: "Stafford County",
	county_20187: "Stanton County",
	county_20189: "Stevens County",
	county_20191: "Sumner County",
	county_20193: "Thomas County",
	county_20195: "Trego County",
	county_20197: "Wabaunsee County",
	county_20199: "Wallace County",
	county_20201: "Washington County",
	county_20203: "Wichita County",
	county_20205: "Wilson County",
	county_20207: "Woodson County",
	county_20209: "Wyandotte County",
	county_21001: "Adair County",
	county_21003: "Allen County",
	county_21005: "Anderson County",
	county_21007: "Ballard County",
	county_21009: "Barren County",
	county_21011: "Bath County",
	county_21013: "Bell County",
	county_21015: "Boone County",
	county_21017: "Bourbon County",
	county_21019: "Boyd County",
	county_21021: "Boyle County",
	county_21023: "Bracken County",
	county_21025: "Breathitt County",
	county_21027: "Breckinridge County",
	county_21029: "Bullitt County",
	county_21031: "Butler County",
	county_21033: "Caldwell County",
	county_21035: "Calloway County",
	county_21037: "Campbell County",
	county_21039: "Carlisle County",
	county_21041: "Carroll County",
	county_21043: "Carter County",
	county_21045: "Casey County",
	county_21047: "Christian County",
	county_21049: "Clark County",
	county_21051: "Clay County",
	county_21053: "Clinton County",
	county_21055: "Crittenden County",
	county_21057: "Cumberland County",
	county_21059: "Daviess County",
	county_21061: "Edmonson County",
	county_21063: "Elliott County",
	county_21065: "Estill County",
	county_21067: "Fayette County",
	county_21069: "Fleming County",
	county_21071: "Floyd County",
	county_21073: "Franklin County",
	county_21075: "Fulton County",
	county_21077: "Gallatin County",
	county_21079: "Garrard County",
	county_21081: "Grant County",
	county_21083: "Graves County",
	county_21085: "Grayson County",
	county_21087: "Green County",
	county_21089: "Greenup County",
	county_21091: "Hancock County",
	county_21093: "Hardin County",
	county_21095: "Harlan County",
	county_21097: "Harrison County",
	county_21099: "Hart County",
	county_21101: "Henderson County",
	county_21103: "Henry County",
	county_21105: "Hickman County",
	county_21107: "Hopkins County",
	county_21109: "Jackson County",
	county_21111: "Jefferson County",
	county_21113: "Jessamine County",
	county_21115: "Johnson County",
	county_21117: "Kenton County",
	county_21119: "Knott County",
	county_21121: "Knox County",
	county_21123: "Larue County",
	county_21125: "Laurel County",
	county_21127: "Lawrence County",
	county_21129: "Lee County",
	county_21131: "Leslie County",
	county_21133: "Letcher County",
	county_21135: "Lewis County",
	county_21137: "Lincoln County",
	county_21139: "Livingston County",
	county_21141: "Logan County",
	county_21143: "Lyon County",
	county_21145: "McCracken County",
	county_21147: "McCreary County",
	county_21149: "McLean County",
	county_21151: "Madison County",
	county_21153: "Magoffin County",
	county_21155: "Marion County",
	county_21157: "Marshall County",
	county_21159: "Martin County",
	county_21161: "Mason County",
	county_21163: "Meade County",
	county_21165: "Menifee County",
	county_21167: "Mercer County",
	county_21169: "Metcalfe County",
	county_21171: "Monroe County",
	county_21173: "Montgomery County",
	county_21175: "Morgan County",
	county_21177: "Muhlenberg County",
	county_21179: "Nelson County",
	county_21181: "Nicholas County",
	county_21183: "Ohio County",
	county_21185: "Oldham County",
	county_21187: "Owen County",
	county_21189: "Owsley County",
	county_21191: "Pendleton County",
	county_21193: "Perry County",
	county_21195: "Pike County",
	county_21197: "Powell County",
	county_21199: "Pulaski County",
	county_21201: "Robertson County",
	county_21203: "Rockcastle County",
	county_21205: "Rowan County",
	county_21207: "Russell County",
	county_21209: "Scott County",
	county_21211: "Shelby County",
	county_21213: "Simpson County",
	county_21215: "Spencer County",
	county_21217: "Taylor County",
	county_21219: "Todd County",
	county_21221: "Trigg County",
	county_21223: "Trimble County",
	county_21225: "Union County",
	county_21227: "Warren County",
	county_21229: "Washington County",
	county_21231: "Wayne County",
	county_21233: "Webster County",
	county_21235: "Whitley County",
	county_21237: "Wolfe County",
	county_21239: "Woodford County",
	county_22001: "Acadia Parish",
	county_22003: "Allen Parish",
	county_22005: "Ascension Parish",
	county_22007: "Assumption Parish",
	county_22009: "Avoyelles Parish",
	county_22011: "Beauregard Parish",
	county_22013: "Bienville Parish",
	county_22015: "Bossier Parish",
	county_22017: "Caddo Parish",
	county_22019: "Calcasieu Parish",
	county_22021: "Caldwell Parish",
	county_22023: "Cameron Parish",
	county_22025: "Catahoula Parish",
	county_22027: "Claiborne Parish",
	county_22029: "Concordia Parish",
	county_22031: "De Soto Parish",
	county_22033: "East Baton Rouge Parish",
	county_22035: "East Carroll Parish",
	county_22037: "East Feliciana Parish",
	county_22039: "Evangeline Parish",
	county_22041: "Franklin Parish",
	county_22043: "Grant Parish",
	county_22045: "Iberia Parish",
	county_22047: "Iberville Parish",
	county_22049: "Jackson Parish",
	county_22051: "Jefferson Parish",
	county_22053: "Jefferson Davis Parish",
	county_22055: "Lafayette Parish",
	county_22057: "Lafourche Parish",
	county_22059: "LaSalle Parish",
	county_22061: "Lincoln Parish",
	county_22063: "Livingston Parish",
	county_22065: "Madison Parish",
	county_22067: "Morehouse Parish",
	county_22069: "Natchitoches Parish",
	county_22071: "Orleans Parish",
	county_22073: "Ouachita Parish",
	county_22075: "Plaquemines Parish",
	county_22077: "Pointe Coupee Parish",
	county_22079: "Rapides Parish",
	county_22081: "Red River Parish",
	county_22083: "Richland Parish",
	county_22085: "Sabine Parish",
	county_22087: "St. Bernard Parish",
	county_22089: "St. Charles Parish",
	county_22091: "St. Helena Parish",
	county_22093: "St. James Parish",
	county_22095: "St. John the Baptist Parish",
	county_22097: "St. Landry Parish",
	county_22099: "St. Martin Parish",
	county_22101: "St. Mary Parish",
	county_22103: "St. Tammany Parish",
	county_22105: "Tangipahoa Parish",
	county_22107: "Tensas Parish",
	county_22109: "Terrebonne Parish",
	county_22111: "Union Parish",
	county_22113: "Vermilion Parish",
	county_22115: "Vernon Parish",
	county_22117: "Washington Parish",
	county_22119: "Webster Parish",
	county_22121: "West Baton Rouge Parish",
	county_22123: "West Carroll Parish",
	county_22125: "West Feliciana Parish",
	county_22127: "Winn Parish",
	county_23001: "Androscoggin County",
	county_23003: "Aroostook County",
	county_23005: "Cumberland County",
	county_23007: "Franklin County",
	county_23009: "Hancock County",
	county_23011: "Kennebec County",
	county_23013: "Knox County",
	county_23015: "Lincoln County",
	county_23017: "Oxford County",
	county_23019: "Penobscot County",
	county_23021: "Piscataquis County",
	county_23023: "Sagadahoc County",
	county_23025: "Somerset County",
	county_23027: "Waldo County",
	county_23029: "Washington County",
	county_23031: "York County",
	county_24001: "Allegany County",
	county_24003: "Anne Arundel County",
	county_24005: "Baltimore County",
	county_24009: "Calvert County",
	county_24011: "Caroline County",
	county_24013: "Carroll County",
	county_24015: "Cecil County",
	county_24017: "Charles County",
	county_24019: "Dorchester County",
	county_24021: "Frederick County",
	county_24023: "Garrett County",
	county_24025: "Harford County",
	county_24027: "Howard County",
	county_24029: "Kent County",
	county_24031: "Montgomery-Prince George's Counties",
	county_24035: "Queen Anne's County",
	county_24037: "St. Mary's County",
	county_24039: "Somerset County",
	county_24041: "Talbot County",
	county_24043: "Washington County",
	county_24045: "Wicomico County",
	county_24047: "Worcester County",
	county_24510: "Baltimore city",
	county_25001: "Barnstable County",
	county_25003: "Berkshire County",
	county_25005: "Bristol County",
	county_25007: "Dukes County",
	county_25009: "Essex County",
	county_25011: "Franklin County",
	county_25013: "Hampden County",
	county_25015: "Hampshire County",
	county_25017: "Middlesex County",
	county_25019: "Nantucket County",
	county_25021: "Norfolk County",
	county_25023: "Plymouth County",
	county_25025: "Suffolk County",
	county_25027: "Worcester County",
	county_26001: "Alcona County",
	county_26003: "Alger County",
	county_26005: "Allegan County",
	county_26007: "Alpena County",
	county_26009: "Antrim County",
	county_26011: "Arenac County",
	county_26013: "Baraga County",
	county_26015: "Barry County",
	county_26017: "Bay County",
	county_26019: "Benzie County",
	county_26021: "Berrien County",
	county_26023: "Branch County",
	county_26025: "Calhoun County",
	county_26027: "Cass County",
	county_26029: "Charlevoix County",
	county_26031: "Cheboygan County",
	county_26033: "Chippewa County",
	county_26035: "Clare County",
	county_26037: "Clinton County",
	county_26039: "Crawford County",
	county_26041: "Delta County",
	county_26043: "Dickinson County",
	county_26045: "Eaton County",
	county_26047: "Emmet County",
	county_26049: "Genesee County",
	county_26051: "Gladwin County",
	county_26053: "Gogebic County",
	county_26055: "Grand Traverse County",
	county_26057: "Gratiot County",
	county_26059: "Hillsdale County",
	county_26061: "Houghton County",
	county_26063: "Huron County",
	county_26065: "Ingham County",
	county_26067: "Ionia County",
	county_26069: "Iosco County",
	county_26071: "Iron County",
	county_26073: "Isabella County",
	county_26075: "Jackson County",
	county_26077: "Kalamazoo County",
	county_26079: "Kalkaska County",
	county_26081: "Kent County",
	county_26083: "Keweenaw County",
	county_26085: "Lake County",
	county_26087: "Lapeer County",
	county_26089: "Leelanau County",
	county_26091: "Lenawee County",
	county_26093: "Livingston County",
	county_26095: "Luce County",
	county_26097: "Mackinac County",
	county_26099: "Macomb County",
	county_26101: "Manistee County",
	county_26103: "Marquette County",
	county_26105: "Mason County",
	county_26107: "Mecosta County",
	county_26109: "Menominee County",
	county_26111: "Midland County",
	county_26113: "Missaukee County",
	county_26115: "Monroe County",
	county_26117: "Montcalm County",
	county_26119: "Montmorency County",
	county_26121: "Muskegon County",
	county_26123: "Newaygo County",
	county_26125: "Oakland County",
	county_26127: "Oceana County",
	county_26129: "Ogemaw County",
	county_26131: "Ontonagon County",
	county_26133: "Osceola County",
	county_26135: "Oscoda County",
	county_26137: "Otsego County",
	county_26139: "Ottawa County",
	county_26141: "Presque Isle County",
	county_26143: "Roscommon County",
	county_26145: "Saginaw County",
	county_26147: "St. Clair County",
	county_26149: "St. Joseph County",
	county_26151: "Sanilac County",
	county_26153: "Schoolcraft County",
	county_26155: "Shiawassee County",
	county_26157: "Tuscola County",
	county_26159: "Van Buren County",
	county_26161: "Washtenaw County",
	county_26163: "Wayne County",
	county_26165: "Wexford County",
	county_27001: "Aitkin County",
	county_27003: "Anoka County",
	county_27005: "Becker County",
	county_27007: "Beltrami County",
	county_27009: "Benton County",
	county_27011: "Big Stone County",
	county_27013: "Blue Earth County",
	county_27015: "Brown County",
	county_27017: "Carlton County",
	county_27019: "Carver County",
	county_27021: "Cass County",
	county_27023: "Chippewa County",
	county_27025: "Chisago County",
	county_27027: "Clay County",
	county_27029: "Clearwater County",
	county_27031: "Cook County",
	county_27033: "Cottonwood County",
	county_27035: "Crow Wing County",
	county_27037: "Dakota County",
	county_27039: "Dodge County",
	county_27041: "Douglas County",
	county_27043: "Faribault County",
	county_27045: "Fillmore County",
	county_27047: "Freeborn County",
	county_27049: "Goodhue County",
	county_27051: "Grant County",
	county_27053: "Hennepin County",
	county_27055: "Houston County",
	county_27057: "Hubbard County",
	county_27059: "Isanti County",
	county_27061: "Itasca County",
	county_27063: "Jackson County",
	county_27065: "Kanabec County",
	county_27067: "Kandiyohi County",
	county_27069: "Kittson County",
	county_27071: "Koochiching County",
	county_27073: "Lac qui Parle County",
	county_27075: "Lake County",
	county_27077: "Lake of the Woods County",
	county_27079: "Le Sueur County",
	county_27081: "Lincoln County",
	county_27083: "Lyon County",
	county_27085: "McLeod County",
	county_27087: "Mahnomen County",
	county_27089: "Marshall County",
	county_27091: "Martin County",
	county_27093: "Meeker County",
	county_27095: "Mille Lacs County",
	county_27097: "Morrison County",
	county_27099: "Mower County",
	county_27101: "Murray County",
	county_27103: "Nicollet County",
	county_27105: "Nobles County",
	county_27107: "Norman County",
	county_27109: "Olmsted County",
	county_27111: "Otter Tail County",
	county_27113: "Pennington County",
	county_27115: "Pine County",
	county_27117: "Pipestone County",
	county_27119: "Polk County",
	county_27121: "Pope County",
	county_27123: "Ramsey County",
	county_27125: "Red Lake County",
	county_27127: "Redwood County",
	county_27129: "Renville County",
	county_27131: "Rice County",
	county_27133: "Rock County",
	county_27135: "Roseau County",
	county_27137: "St. Louis County",
	county_27139: "Scott County",
	county_27141: "Sherburne County",
	county_27143: "Sibley County",
	county_27145: "Stearns County",
	county_27147: "Steele County",
	county_27149: "Stevens County",
	county_27151: "Swift County",
	county_27153: "Todd County",
	county_27155: "Traverse County",
	county_27157: "Wabasha County",
	county_27159: "Wadena County",
	county_27161: "Waseca County",
	county_27163: "Washington County",
	county_27165: "Watonwan County",
	county_27167: "Wilkin County",
	county_27169: "Winona County",
	county_27171: "Wright County",
	county_27173: "Yellow Medicine County",
	county_28001: "Adams County",
	county_28003: "Alcorn County",
	county_28005: "Amite County",
	county_28007: "Attala County",
	county_28009: "Benton County",
	county_28011: "Bolivar County",
	county_28013: "Calhoun County",
	county_28015: "Carroll County",
	county_28017: "Chickasaw County",
	county_28019: "Choctaw County",
	county_28021: "Claiborne County",
	county_28023: "Clarke County",
	county_28025: "Clay County",
	county_28027: "Coahoma County",
	county_28029: "Copiah County",
	county_28031: "Covington County",
	county_28033: "DeSoto County",
	county_28035: "Forrest County",
	county_28037: "Franklin County",
	county_28039: "George County",
	county_28041: "Greene County",
	county_28043: "Grenada County",
	county_28045: "Hancock County",
	county_28047: "Harrison County",
	county_28049: "Hinds County",
	county_28051: "Holmes County",
	county_28053: "Humphreys County",
	county_28055: "Issaquena County",
	county_28057: "Itawamba County",
	county_28059: "Jackson County",
	county_28061: "Jasper County",
	county_28063: "Jefferson County",
	county_28065: "Jefferson Davis County",
	county_28067: "Jones County",
	county_28069: "Kemper County",
	county_28071: "Lafayette County",
	county_28073: "Lamar County",
	county_28075: "Lauderdale County",
	county_28077: "Lawrence County",
	county_28079: "Leake County",
	county_28081: "Lee County",
	county_28083: "Leflore County",
	county_28085: "Lincoln County",
	county_28087: "Lowndes County",
	county_28089: "Madison County",
	county_28091: "Marion County",
	county_28093: "Marshall County",
	county_28095: "Monroe County",
	county_28097: "Montgomery County",
	county_28099: "Neshoba County",
	county_28101: "Newton County",
	county_28103: "Noxubee County",
	county_28105: "Oktibbeha County",
	county_28107: "Panola County",
	county_28109: "Pearl River County",
	county_28111: "Perry County",
	county_28113: "Pike County",
	county_28115: "Pontotoc County",
	county_28117: "Prentiss County",
	county_28119: "Quitman County",
	county_28121: "Rankin County",
	county_28123: "Scott County",
	county_28125: "Sharkey County",
	county_28127: "Simpson County",
	county_28129: "Smith County",
	county_28131: "Stone County",
	county_28133: "Sunflower County",
	county_28135: "Tallahatchie County",
	county_28137: "Tate County",
	county_28139: "Tippah County",
	county_28141: "Tishomingo County",
	county_28143: "Tunica County",
	county_28145: "Union County",
	county_28147: "Walthall County",
	county_28149: "Warren County",
	county_28151: "Washington County",
	county_28153: "Wayne County",
	county_28155: "Webster County",
	county_28157: "Wilkinson County",
	county_28159: "Winston County",
	county_28161: "Yalobusha County",
	county_28163: "Yazoo County",
	county_29001: "Adair County",
	county_29003: "Andrew County",
	county_29005: "Atchison County",
	county_29007: "Audrain County",
	county_29009: "Barry County",
	county_29011: "Barton County",
	county_29013: "Bates County",
	county_29015: "Benton County",
	county_29017: "Bollinger County",
	county_29019: "Boone County",
	county_29021: "Buchanan County",
	county_29023: "Butler County",
	county_29025: "Caldwell County",
	county_29027: "Callaway County",
	county_29029: "Camden County",
	county_29031: "Cape Girardeau County",
	county_29033: "Carroll County",
	county_29035: "Carter County",
	county_29037: "Cass County",
	county_29039: "Cedar County",
	county_29041: "Chariton County",
	county_29043: "Christian County",
	county_29045: "Clark County",
	county_29047: "Clay County",
	county_29049: "Clinton County",
	county_29051: "Cole County",
	county_29053: "Cooper County",
	county_29055: "Crawford County",
	county_29057: "Dade County",
	county_29059: "Dallas County",
	county_29061: "Daviess County",
	county_29063: "DeKalb County",
	county_29065: "Dent County",
	county_29067: "Douglas County",
	county_29069: "Dunklin County",
	county_29071: "Franklin County",
	county_29073: "Gasconade County",
	county_29075: "Gentry County",
	county_29077: "Greene County",
	county_29079: "Grundy County",
	county_29081: "Harrison County",
	county_29083: "Henry County",
	county_29085: "Hickory County",
	county_29087: "Holt County",
	county_29089: "Howard County",
	county_29091: "Howell County",
	county_29093: "Iron County",
	county_29095: "Jackson County",
	county_29097: "Jasper County",
	county_29099: "Jefferson County",
	county_29101: "Johnson County",
	county_29103: "Knox County",
	county_29105: "Laclede County",
	county_29107: "Lafayette County",
	county_29109: "Lawrence County",
	county_29111: "Lewis County",
	county_29113: "Lincoln County",
	county_29115: "Linn County",
	county_29117: "Livingston County",
	county_29119: "McDonald County",
	county_29121: "Macon County",
	county_29123: "Madison County",
	county_29125: "Maries County",
	county_29127: "Marion County",
	county_29129: "Mercer County",
	county_29131: "Miller County",
	county_29133: "Mississippi County",
	county_29135: "Moniteau County",
	county_29137: "Monroe County",
	county_29139: "Montgomery County",
	county_29141: "Morgan County",
	county_29143: "New Madrid County",
	county_29145: "Newton County",
	county_29147: "Nodaway County",
	county_29149: "Oregon County",
	county_29151: "Osage County",
	county_29153: "Ozark County",
	county_29155: "Pemiscot County",
	county_29157: "Perry County",
	county_29159: "Pettis County",
	county_29161: "Phelps County",
	county_29163: "Pike County",
	county_29165: "Platte County",
	county_29167: "Polk County",
	county_29169: "Pulaski County",
	county_29171: "Putnam County",
	county_29173: "Ralls County",
	county_29175: "Randolph County",
	county_29177: "Ray County",
	county_29179: "Reynolds County",
	county_29181: "Ripley County",
	county_29183: "St. Charles County",
	county_29185: "St. Clair County",
	county_29186: "Ste. Genevieve County",
	county_29187: "St. Francois County",
	county_29189: "St. Louis County",
	county_29195: "Saline County",
	county_29197: "Schuyler County",
	county_29199: "Scotland County",
	county_29201: "Scott County",
	county_29203: "Shannon County",
	county_29205: "Shelby County",
	county_29207: "Stoddard County",
	county_29209: "Stone County",
	county_29211: "Sullivan County",
	county_29213: "Taney County",
	county_29215: "Texas County",
	county_29217: "Vernon County",
	county_29219: "Warren County",
	county_29221: "Washington County",
	county_29223: "Wayne County",
	county_29225: "Webster County",
	county_29227: "Worth County",
	county_29229: "Wright County",
	county_29510: "St. Louis city",
	county_30001: "Beaverhead County",
	county_30003: "Big Horn County",
	county_30005: "Blaine County",
	county_30007: "Broadwater County",
	county_30009: "Carbon County",
	county_30011: "Carter County",
	county_30013: "Cascade County",
	county_30015: "Chouteau County",
	county_30017: "Custer County",
	county_30019: "Daniels County",
	county_30021: "Dawson County",
	county_30023: "Deer Lodge County",
	county_30025: "Fallon County",
	county_30027: "Fergus County",
	county_30029: "Flathead County",
	county_30031: "Gallatin-Park Counties",
	county_30033: "Garfield County",
	county_30035: "Glacier County",
	county_30037: "Golden Valley County",
	county_30039: "Granite County",
	county_30041: "Hill County",
	county_30043: "Jefferson County",
	county_30045: "Judith Basin County",
	county_30047: "Lake County",
	county_30049: "Lewis and Clark County",
	county_30051: "Liberty County",
	county_30053: "Lincoln County",
	county_30055: "McCone County",
	county_30057: "Madison County",
	county_30059: "Meagher County",
	county_30061: "Mineral County",
	county_30063: "Missoula County",
	county_30065: "Musselshell County",
	county_30069: "Petroleum County",
	county_30071: "Phillips County",
	county_30073: "Pondera County",
	county_30075: "Powder River County",
	county_30077: "Powell County",
	county_30079: "Prairie County",
	county_30081: "Ravalli County",
	county_30083: "Richland County",
	county_30085: "Roosevelt County",
	county_30087: "Rosebud County",
	county_30089: "Sanders County",
	county_30091: "Sheridan County",
	county_30093: "Silver Bow County",
	county_30095: "Stillwater County",
	county_30097: "Sweet Grass County",
	county_30099: "Teton County",
	county_30101: "Toole County",
	county_30103: "Treasure County",
	county_30105: "Valley County",
	county_30107: "Wheatland County",
	county_30109: "Wibaux County",
	county_30111: "Yellowstone County",
	county_31001: "Adams County",
	county_31003: "Antelope County",
	county_31005: "Arthur County",
	county_31007: "Banner County",
	county_31009: "Blaine County",
	county_31011: "Boone County",
	county_31013: "Box Butte County",
	county_31015: "Boyd County",
	county_31017: "Brown County",
	county_31019: "Buffalo County",
	county_31021: "Burt County",
	county_31023: "Butler County",
	county_31025: "Cass County",
	county_31027: "Cedar County",
	county_31029: "Chase County",
	county_31031: "Cherry County",
	county_31033: "Cheyenne County",
	county_31035: "Clay County",
	county_31037: "Colfax County",
	county_31039: "Cuming County",
	county_31041: "Custer County",
	county_31043: "Dakota County",
	county_31045: "Dawes County",
	county_31047: "Dawson County",
	county_31049: "Deuel County",
	county_31051: "Dixon County",
	county_31053: "Dodge County",
	county_31055: "Douglas County",
	county_31057: "Dundy County",
	county_31059: "Fillmore County",
	county_31061: "Franklin County",
	county_31063: "Frontier County",
	county_31065: "Furnas County",
	county_31067: "Gage County",
	county_31069: "Garden County",
	county_31071: "Garfield County",
	county_31073: "Gosper County",
	county_31075: "Grant County",
	county_31077: "Greeley County",
	county_31079: "Hall County",
	county_31081: "Hamilton County",
	county_31083: "Harlan County",
	county_31085: "Hayes County",
	county_31087: "Hitchcock County",
	county_31089: "Holt County",
	county_31091: "Hooker County",
	county_31093: "Howard County",
	county_31095: "Jefferson County",
	county_31097: "Johnson County",
	county_31099: "Kearney County",
	county_31101: "Keith County",
	county_31103: "Keya Paha County",
	county_31105: "Kimball County",
	county_31107: "Knox County",
	county_31109: "Lancaster County",
	county_31111: "Lincoln County",
	county_31113: "Logan County",
	county_31115: "Loup County",
	county_31117: "McPherson County",
	county_31119: "Madison County",
	county_31121: "Merrick County",
	county_31123: "Morrill County",
	county_31125: "Nance County",
	county_31127: "Nemaha County",
	county_31129: "Nuckolls County",
	county_31131: "Otoe County",
	county_31133: "Pawnee County",
	county_31135: "Perkins County",
	county_31137: "Phelps County",
	county_31139: "Pierce County",
	county_31141: "Platte County",
	county_31143: "Polk County",
	county_31145: "Red Willow County",
	county_31147: "Richardson County",
	county_31149: "Rock County",
	county_31151: "Saline County",
	county_31153: "Sarpy County",
	county_31155: "Saunders County",
	county_31157: "Scotts Bluff County",
	county_31159: "Seward County",
	county_31161: "Sheridan County",
	county_31163: "Sherman County",
	county_31165: "Sioux County",
	county_31167: "Stanton County",
	county_31169: "Thayer County",
	county_31171: "Thomas County",
	county_31173: "Thurston County",
	county_31175: "Valley County",
	county_31177: "Washington County",
	county_31179: "Wayne County",
	county_31181: "Webster County",
	county_31183: "Wheeler County",
	county_31185: "York County",
	county_32001: "Churchill County",
	county_32003: "Clark County",
	county_32005: "Douglas County",
	county_32007: "Elko County",
	county_32009: "Esmeralda County",
	county_32011: "Eureka County",
	county_32013: "Humboldt County",
	county_32015: "Lander County",
	county_32017: "Lincoln County",
	county_32019: "Lyon County",
	county_32021: "Mineral County",
	county_32023: "Nye County",
	county_32027: "Pershing County",
	county_32029: "Storey County",
	county_32031: "Washoe County",
	county_32033: "White Pine County",
	county_32510: "Carson City",
	county_33001: "Belknap County",
	county_33003: "Carroll County",
	county_33005: "Cheshire County",
	county_33007: "Coos County",
	county_33009: "Grafton County",
	county_33011: "Hillsborough County",
	county_33013: "Merrimack County",
	county_33015: "Rockingham County",
	county_33017: "Strafford County",
	county_33019: "Sullivan County",
	county_34001: "Atlantic County",
	county_34003: "Bergen County",
	county_34005: "Burlington County",
	county_34007: "Camden County",
	county_34009: "Cape May County",
	county_34011: "Cumberland County",
	county_34013: "Essex County",
	county_34015: "Gloucester County",
	county_34017: "Hudson County",
	county_34019: "Hunterdon County",
	county_34021: "Mercer County",
	county_34023: "Middlesex County",
	county_34025: "Monmouth County",
	county_34027: "Morris County",
	county_34029: "Ocean County",
	county_34031: "Passaic County",
	county_34033: "Salem County",
	county_34035: "Somerset County",
	county_34037: "Sussex County",
	county_34039: "Union County",
	county_34041: "Warren County",
	county_35001: "Bernalillo County",
	county_35003: "Catron County",
	county_35005: "Chaves County",
	county_35006: "Cibola-Valencia Counties",
	county_35007: "Colfax County",
	county_35009: "Curry County",
	county_35011: "De Baca County",
	county_35013: "Doña Ana County",
	county_35015: "Eddy County",
	county_35017: "Grant County",
	county_35019: "Guadalupe County",
	county_35021: "Harding County",
	county_35023: "Hidalgo County",
	county_35025: "Lea County",
	county_35027: "Lincoln County",
	county_35028: "Los Alamos County",
	county_35029: "Luna County",
	county_35031: "McKinley County",
	county_35033: "Mora County",
	county_35035: "Otero County",
	county_35037: "Quay County",
	county_35039: "Rio Arriba County",
	county_35041: "Roosevelt County",
	county_35043: "Sandoval County",
	county_35045: "San Juan County",
	county_35047: "San Miguel County",
	county_35049: "Santa Fe County",
	county_35051: "Sierra County",
	county_35053: "Socorro County",
	county_35055: "Taos County",
	county_35057: "Torrance County",
	county_35059: "Union County",
	county_36001: "Albany County",
	county_36003: "Allegany County",
	county_36005: "New York City",
	county_36007: "Broome County",
	county_36009: "Cattaraugus County",
	county_36011: "Cayuga County",
	county_36013: "Chautauqua County",
	county_36015: "Chemung County",
	county_36017: "Chenango County",
	county_36019: "Clinton County",
	county_36021: "Columbia County",
	county_36023: "Cortland County",
	county_36025: "Delaware County",
	county_36027: "Dutchess County",
	county_36029: "Erie County",
	county_36031: "Essex County",
	county_36033: "Franklin County",
	county_36035: "Fulton County",
	county_36037: "Genesee County",
	county_36039: "Greene County",
	county_36041: "Hamilton County",
	county_36043: "Herkimer County",
	county_36045: "Jefferson County",
	county_36049: "Lewis County",
	county_36051: "Livingston County",
	county_36053: "Madison County",
	county_36055: "Monroe County",
	county_36057: "Montgomery County",
	county_36059: "Nassau County",
	county_36063: "Niagara County",
	county_36065: "Oneida County",
	county_36067: "Onondaga County",
	county_36069: "Ontario County",
	county_36071: "Orange County",
	county_36073: "Orleans County",
	county_36075: "Oswego County",
	county_36077: "Otsego County",
	county_36079: "Putnam County",
	county_36083: "Rensselaer County",
	county_36087: "Rockland County",
	county_36089: "St. Lawrence County",
	county_36091: "Saratoga County",
	county_36093: "Schenectady County",
	county_36095: "Schoharie County",
	county_36097: "Schuyler County",
	county_36099: "Seneca County",
	county_36101: "Steuben County",
	county_36103: "Suffolk County",
	county_36105: "Sullivan County",
	county_36107: "Tioga County",
	county_36109: "Tompkins County",
	county_36111: "Ulster County",
	county_36113: "Warren County",
	county_36115: "Washington County",
	county_36117: "Wayne County",
	county_36119: "Westchester County",
	county_36121: "Wyoming County",
	county_36123: "Yates County",
	county_37001: "Alamance County",
	county_37003: "Alexander County",
	county_37005: "Alleghany County",
	county_37007: "Anson County",
	county_37009: "Ashe County",
	county_37011: "Avery County",
	county_37013: "Beaufort County",
	county_37015: "Bertie County",
	county_37017: "Bladen County",
	county_37019: "Brunswick County",
	county_37021: "Buncombe County",
	county_37023: "Burke County",
	county_37025: "Cabarrus County",
	county_37027: "Caldwell County",
	county_37029: "Camden County",
	county_37031: "Carteret County",
	county_37033: "Caswell County",
	county_37035: "Catawba County",
	county_37037: "Chatham County",
	county_37039: "Cherokee County",
	county_37041: "Chowan County",
	county_37043: "Clay County",
	county_37045: "Cleveland County",
	county_37047: "Columbus County",
	county_37049: "Craven County",
	county_37051: "Cumberland County",
	county_37053: "Currituck County",
	county_37055: "Dare County",
	county_37057: "Davidson County",
	county_37059: "Davie County",
	county_37061: "Duplin County",
	county_37063: "Durham County",
	county_37065: "Edgecombe County",
	county_37067: "Forsyth County",
	county_37069: "Franklin County",
	county_37071: "Gaston County",
	county_37073: "Gates County",
	county_37075: "Graham County",
	county_37077: "Granville County",
	county_37079: "Greene County",
	county_37081: "Guilford County",
	county_37083: "Halifax County",
	county_37085: "Harnett County",
	county_37087: "Haywood County",
	county_37089: "Henderson County",
	county_37091: "Hertford County",
	county_37093: "Hoke County",
	county_37095: "Hyde County",
	county_37097: "Iredell County",
	county_37099: "Jackson County",
	county_37101: "Johnston County",
	county_37103: "Jones County",
	county_37105: "Lee County",
	county_37107: "Lenoir County",
	county_37109: "Lincoln County",
	county_37111: "McDowell County",
	county_37113: "Macon County",
	county_37115: "Madison County",
	county_37117: "Martin County",
	county_37119: "Mecklenburg County",
	county_37121: "Mitchell County",
	county_37123: "Montgomery County",
	county_37125: "Moore County",
	county_37127: "Nash County",
	county_37129: "New Hanover County",
	county_37131: "Northampton County",
	county_37133: "Onslow County",
	county_37135: "Orange County",
	county_37137: "Pamlico County",
	county_37139: "Pasquotank County",
	county_37141: "Pender County",
	county_37143: "Perquimans County",
	county_37145: "Person County",
	county_37147: "Pitt County",
	county_37149: "Polk County",
	county_37151: "Randolph County",
	county_37153: "Richmond County",
	county_37155: "Robeson County",
	county_37157: "Rockingham County",
	county_37159: "Rowan County",
	county_37161: "Rutherford County",
	county_37163: "Sampson County",
	county_37165: "Scotland County",
	county_37167: "Stanly County",
	county_37169: "Stokes County",
	county_37171: "Surry County",
	county_37173: "Swain County",
	county_37175: "Transylvania County",
	county_37177: "Tyrrell County",
	county_37179: "Union County",
	county_37181: "Vance County",
	county_37183: "Wake County",
	county_37185: "Warren County",
	county_37187: "Washington County",
	county_37189: "Watauga County",
	county_37191: "Wayne County",
	county_37193: "Wilkes County",
	county_37195: "Wilson County",
	county_37197: "Yadkin County",
	county_37199: "Yancey County",
	county_38001: "Adams County",
	county_38003: "Barnes County",
	county_38005: "Benson County",
	county_38007: "Billings County",
	county_38009: "Bottineau County",
	county_38011: "Bowman County",
	county_38013: "Burke County",
	county_38015: "Burleigh County",
	county_38017: "Cass County",
	county_38019: "Cavalier County",
	county_38021: "Dickey County",
	county_38023: "Divide County",
	county_38025: "Dunn County",
	county_38027: "Eddy County",
	county_38029: "Emmons County",
	county_38031: "Foster County",
	county_38033: "Golden Valley County",
	county_38035: "Grand Forks County",
	county_38037: "Grant County",
	county_38039: "Griggs County",
	county_38041: "Hettinger County",
	county_38043: "Kidder County",
	county_38045: "LaMoure County",
	county_38047: "Logan County",
	county_38049: "McHenry County",
	county_38051: "McIntosh County",
	county_38053: "McKenzie County",
	county_38055: "McLean County",
	county_38057: "Mercer County",
	county_38059: "Morton County",
	county_38061: "Mountrail County",
	county_38063: "Nelson County",
	county_38065: "Oliver County",
	county_38067: "Pembina County",
	county_38069: "Pierce County",
	county_38071: "Ramsey County",
	county_38073: "Ransom County",
	county_38075: "Renville County",
	county_38077: "Richland County",
	county_38079: "Rolette County",
	county_38081: "Sargent County",
	county_38083: "Sheridan County",
	county_38085: "Sioux County",
	county_38087: "Slope County",
	county_38089: "Stark County",
	county_38091: "Steele County",
	county_38093: "Stutsman County",
	county_38095: "Towner County",
	county_38097: "Traill County",
	county_38099: "Walsh County",
	county_38101: "Ward County",
	county_38103: "Wells County",
	county_38105: "Williams County",
	county_39001: "Adams County",
	county_39003: "Allen County",
	county_39005: "Ashland County",
	county_39007: "Ashtabula County",
	county_39009: "Athens County",
	county_39011: "Auglaize County",
	county_39013: "Belmont County",
	county_39015: "Brown County",
	county_39017: "Butler County",
	county_39019: "Carroll County",
	county_39021: "Champaign County",
	county_39023: "Clark County",
	county_39025: "Clermont County",
	county_39027: "Clinton County",
	county_39029: "Columbiana County",
	county_39031: "Coshocton County",
	county_39033: "Crawford County",
	county_39035: "Cuyahoga County",
	county_39037: "Darke County",
	county_39039: "Defiance County",
	county_39041: "Delaware County",
	county_39043: "Erie County",
	county_39045: "Fairfield County",
	county_39047: "Fayette County",
	county_39049: "Franklin County",
	county_39051: "Fulton County",
	county_39053: "Gallia County",
	county_39055: "Geauga County",
	county_39057: "Greene County",
	county_39059: "Guernsey County",
	county_39061: "Hamilton County",
	county_39063: "Hancock County",
	county_39065: "Hardin County",
	county_39067: "Harrison County",
	county_39069: "Henry County",
	county_39071: "Highland County",
	county_39073: "Hocking County",
	county_39075: "Holmes County",
	county_39077: "Huron County",
	county_39079: "Jackson County",
	county_39081: "Jefferson County",
	county_39083: "Knox County",
	county_39085: "Lake County",
	county_39087: "Lawrence County",
	county_39089: "Licking County",
	county_39091: "Logan County",
	county_39093: "Lorain County",
	county_39095: "Lucas County",
	county_39097: "Madison County",
	county_39099: "Mahoning County",
	county_39101: "Marion County",
	county_39103: "Medina County",
	county_39105: "Meigs County",
	county_39107: "Mercer County",
	county_39109: "Miami County",
	county_39111: "Monroe County",
	county_39113: "Montgomery County",
	county_39115: "Morgan County",
	county_39117: "Morrow County",
	county_39119: "Muskingum County",
	county_39121: "Noble County",
	county_39123: "Ottawa County",
	county_39125: "Paulding County",
	county_39127: "Perry County",
	county_39129: "Pickaway County",
	county_39131: "Pike County",
	county_39133: "Portage County",
	county_39135: "Preble County",
	county_39137: "Putnam County",
	county_39139: "Richland County",
	county_39141: "Ross County",
	county_39143: "Sandusky County",
	county_39145: "Scioto County",
	county_39147: "Seneca County",
	county_39149: "Shelby County",
	county_39151: "Stark County",
	county_39153: "Summit County",
	county_39155: "Trumbull County",
	county_39157: "Tuscarawas County",
	county_39159: "Union County",
	county_39161: "Van Wert County",
	county_39163: "Vinton County",
	county_39165: "Warren County",
	county_39167: "Washington County",
	county_39169: "Wayne County",
	county_39171: "Williams County",
	county_39173: "Wood County",
	county_39175: "Wyandot County",
	county_40001: "Adair County",
	county_40003: "Alfalfa County",
	county_40005: "Atoka County",
	county_40007: "Beaver County",
	county_40009: "Beckham County",
	county_40011: "Blaine County",
	county_40013: "Bryan County",
	county_40015: "Caddo County",
	county_40017: "Canadian County",
	county_40019: "Carter County",
	county_40021: "Cherokee County",
	county_40023: "Choctaw County",
	county_40025: "Cimarron County",
	county_40027: "Cleveland County",
	county_40029: "Coal County",
	county_40031: "Comanche County",
	county_40033: "Cotton County",
	county_40035: "Craig County",
	county_40037: "Creek County",
	county_40039: "Custer County",
	county_40041: "Delaware County",
	county_40043: "Dewey County",
	county_40045: "Ellis County",
	county_40047: "Garfield County",
	county_40049: "Garvin County",
	county_40051: "Grady County",
	county_40053: "Grant County",
	county_40055: "Greer County",
	county_40057: "Harmon County",
	county_40059: "Harper County",
	county_40061: "Haskell County",
	county_40063: "Hughes County",
	county_40065: "Jackson County",
	county_40067: "Jefferson County",
	county_40069: "Johnston County",
	county_40071: "Kay County",
	county_40073: "Kingfisher County",
	county_40075: "Kiowa County",
	county_40077: "Latimer County",
	county_40079: "Le Flore County",
	county_40081: "Lincoln County",
	county_40083: "Logan County",
	county_40085: "Love County",
	county_40087: "McClain County",
	county_40089: "McCurtain County",
	county_40091: "McIntosh County",
	county_40093: "Major County",
	county_40095: "Marshall County",
	county_40097: "Mayes County",
	county_40099: "Murray County",
	county_40101: "Muskogee County",
	county_40103: "Noble County",
	county_40105: "Nowata County",
	county_40107: "Okfuskee County",
	county_40109: "Oklahoma County",
	county_40111: "Okmulgee County",
	county_40113: "Osage County",
	county_40115: "Ottawa County",
	county_40117: "Pawnee County",
	county_40119: "Payne County",
	county_40121: "Pittsburg County",
	county_40123: "Pontotoc County",
	county_40125: "Pottawatomie County",
	county_40127: "Pushmataha County",
	county_40129: "Roger Mills County",
	county_40131: "Rogers County",
	county_40133: "Seminole County",
	county_40135: "Sequoyah County",
	county_40137: "Stephens County",
	county_40139: "Texas County",
	county_40141: "Tillman County",
	county_40143: "Tulsa County",
	county_40145: "Wagoner County",
	county_40147: "Washington County",
	county_40149: "Washita County",
	county_40151: "Woods County",
	county_40153: "Woodward County",
	county_41001: "Baker County",
	county_41003: "Benton County",
	county_41005: "Clackamas County",
	county_41007: "Clatsop County",
	county_41009: "Columbia County",
	county_41011: "Coos County",
	county_41013: "Crook County",
	county_41015: "Curry County",
	county_41017: "Deschutes County",
	county_41019: "Douglas County",
	county_41021: "Gilliam County",
	county_41023: "Grant County",
	county_41025: "Harney County",
	county_41027: "Hood River County",
	county_41029: "Jackson County",
	county_41031: "Jefferson County",
	county_41033: "Josephine County",
	county_41035: "Klamath County",
	county_41037: "Lake County",
	county_41039: "Lane County",
	county_41041: "Lincoln County",
	county_41043: "Linn County",
	county_41045: "Malheur County",
	county_41047: "Marion County",
	county_41049: "Morrow County",
	county_41051: "Multnomah County",
	county_41053: "Polk County",
	county_41055: "Sherman County",
	county_41057: "Tillamook County",
	county_41059: "Umatilla County",
	county_41061: "Union County",
	county_41063: "Wallowa County",
	county_41065: "Wasco County",
	county_41067: "Washington County",
	county_41069: "Wheeler County",
	county_41071: "Yamhill County",
	county_42001: "Adams County",
	county_42003: "Allegheny County",
	county_42005: "Armstrong County",
	county_42007: "Beaver County",
	county_42009: "Bedford County",
	county_42011: "Berks County",
	county_42013: "Blair County",
	county_42015: "Bradford County",
	county_42017: "Bucks County",
	county_42019: "Butler County",
	county_42021: "Cambria County",
	county_42023: "Cameron County",
	county_42025: "Carbon County",
	county_42027: "Centre County",
	county_42029: "Chester County",
	county_42031: "Clarion County",
	county_42033: "Clearfield County",
	county_42035: "Clinton County",
	county_42037: "Columbia County",
	county_42039: "Crawford County",
	county_42041: "Cumberland County",
	county_42043: "Dauphin County",
	county_42045: "Delaware County",
	county_42047: "Elk County",
	county_42049: "Erie County",
	county_42051: "Fayette County",
	county_42053: "Forest County",
	county_42055: "Franklin County",
	county_42057: "Fulton County",
	county_42059: "Greene County",
	county_42061: "Huntingdon County",
	county_42063: "Indiana County",
	county_42065: "Jefferson County",
	county_42067: "Juniata County",
	county_42069: "Lackawanna County",
	county_42071: "Lancaster County",
	county_42073: "Lawrence County",
	county_42075: "Lebanon County",
	county_42077: "Lehigh County",
	county_42079: "Luzerne County",
	county_42081: "Lycoming County",
	county_42083: "McKean County",
	county_42085: "Mercer County",
	county_42087: "Mifflin County",
	county_42089: "Monroe County",
	county_42091: "Montgomery County",
	county_42093: "Montour County",
	county_42095: "Northampton County",
	county_42097: "Northumberland County",
	county_42099: "Perry County",
	county_42101: "Philadelphia County",
	county_42103: "Pike County",
	county_42105: "Potter County",
	county_42107: "Schuylkill County",
	county_42109: "Snyder County",
	county_42111: "Somerset County",
	county_42113: "Sullivan County",
	county_42115: "Susquehanna County",
	county_42117: "Tioga County",
	county_42119: "Union County",
	county_42121: "Venango County",
	county_42123: "Warren County",
	county_42125: "Washington County",
	county_42127: "Wayne County",
	county_42129: "Westmoreland County",
	county_42131: "Wyoming County",
	county_42133: "York County",
	county_44001: "Bristol County",
	county_44003: "Kent County",
	county_44005: "Newport County",
	county_44007: "Providence County",
	county_44009: "Washington County",
	county_45001: "Abbeville County",
	county_45003: "Aiken County",
	county_45005: "Allendale County",
	county_45007: "Anderson County",
	county_45009: "Bamberg County",
	county_45011: "Barnwell County",
	county_45013: "Beaufort County",
	county_45015: "Berkeley County",
	county_45017: "Calhoun County",
	county_45019: "Charleston County",
	county_45021: "Cherokee County",
	county_45023: "Chester County",
	county_45025: "Chesterfield County",
	county_45027: "Clarendon County",
	county_45029: "Colleton County",
	county_45031: "Darlington County",
	county_45033: "Dillon County",
	county_45035: "Dorchester County",
	county_45037: "Edgefield County",
	county_45039: "Fairfield County",
	county_45041: "Florence County",
	county_45043: "Georgetown County",
	county_45045: "Greenville County",
	county_45047: "Greenwood County",
	county_45049: "Hampton County",
	county_45051: "Horry County",
	county_45053: "Jasper County",
	county_45055: "Kershaw County",
	county_45057: "Lancaster County",
	county_45059: "Laurens County",
	county_45061: "Lee County",
	county_45063: "Lexington County",
	county_45065: "McCormick County",
	county_45067: "Marion County",
	county_45069: "Marlboro County",
	county_45071: "Newberry County",
	county_45073: "Oconee County",
	county_45075: "Orangeburg County",
	county_45077: "Pickens County",
	county_45079: "Richland County",
	county_45081: "Saluda County",
	county_45083: "Spartanburg County",
	county_45085: "Sumter County",
	county_45087: "Union County",
	county_45089: "Williamsburg County",
	county_45091: "York County",
	county_46003: "Aurora County",
	county_46005: "Beadle County",
	county_46007: "Bennett County",
	county_46009: "Bon Homme County",
	county_46011: "Brookings County",
	county_46013: "Brown County",
	county_46015: "Brule County",
	county_46017: "Buffalo County",
	county_46019: "Butte County",
	county_46021: "Campbell County",
	county_46023: "Charles Mix County",
	county_46025: "Clark County",
	county_46027: "Clay County",
	county_46029: "Codington County",
	county_46031: "Corson County",
	county_46033: "Custer County",
	county_46035: "Davison County",
	county_46037: "Day County",
	county_46039: "Deuel County",
	county_46041: "Dewey County",
	county_46043: "Douglas County",
	county_46045: "Edmunds County",
	county_46047: "Fall River County",
	county_46049: "Faulk County",
	county_46051: "Grant County",
	county_46053: "Gregory County",
	county_46055: "Haakon County",
	county_46057: "Hamlin County",
	county_46059: "Hand County",
	county_46061: "Hanson County",
	county_46063: "Harding County",
	county_46065: "Hughes County",
	county_46067: "Hutchinson County",
	county_46069: "Hyde County",
	county_46071: "Jackson County",
	county_46073: "Jerauld County",
	county_46075: "Jones County",
	county_46077: "Kingsbury County",
	county_46079: "Lake County",
	county_46081: "Lawrence County",
	county_46083: "Lincoln County",
	county_46085: "Lyman County",
	county_46087: "McCook County",
	county_46089: "McPherson County",
	county_46091: "Marshall County",
	county_46093: "Meade County",
	county_46095: "Mellette County",
	county_46097: "Miner County",
	county_46099: "Minnehaha County",
	county_46101: "Moody County",
	county_46102: "Oglala Lakota County",
	county_46103: "Pennington County",
	county_46105: "Perkins County",
	county_46107: "Potter County",
	county_46109: "Roberts County",
	county_46111: "Sanborn County",
	county_46115: "Spink County",
	county_46117: "Stanley County",
	county_46119: "Sully County",
	county_46121: "Todd County",
	county_46123: "Tripp County",
	county_46125: "Turner County",
	county_46127: "Union County",
	county_46129: "Walworth County",
	county_46135: "Yankton County",
	county_46137: "Ziebach County",
	county_47001: "Anderson County",
	county_47003: "Bedford County",
	county_47005: "Benton County",
	county_47007: "Bledsoe County",
	county_47009: "Blount County",
	county_47011: "Bradley County",
	county_47013: "Campbell County",
	county_47015: "Cannon County",
	county_47017: "Carroll County",
	county_47019: "Carter County",
	county_47021: "Cheatham County",
	county_47023: "Chester County",
	county_47025: "Claiborne County",
	county_47027: "Clay County",
	county_47029: "Cocke County",
	county_47031: "Coffee County",
	county_47033: "Crockett County",
	county_47035: "Cumberland County",
	county_47037: "Davidson County",
	county_47039: "Decatur County",
	county_47041: "DeKalb County",
	county_47043: "Dickson County",
	county_47045: "Dyer County",
	county_47047: "Fayette County",
	county_47049: "Fentress County",
	county_47051: "Franklin County",
	county_47053: "Gibson County",
	county_47055: "Giles County",
	county_47057: "Grainger County",
	county_47059: "Greene County",
	county_47061: "Grundy County",
	county_47063: "Hamblen County",
	county_47065: "Hamilton County",
	county_47067: "Hancock County",
	county_47069: "Hardeman County",
	county_47071: "Hardin County",
	county_47073: "Hawkins County",
	county_47075: "Haywood County",
	county_47077: "Henderson County",
	county_47079: "Henry County",
	county_47081: "Hickman County",
	county_47083: "Houston County",
	county_47085: "Humphreys County",
	county_47087: "Jackson County",
	county_47089: "Jefferson County",
	county_47091: "Johnson County",
	county_47093: "Knox County",
	county_47095: "Lake County",
	county_47097: "Lauderdale County",
	county_47099: "Lawrence County",
	county_47101: "Lewis County",
	county_47103: "Lincoln County",
	county_47105: "Loudon County",
	county_47107: "McMinn County",
	county_47109: "McNairy County",
	county_47111: "Macon County",
	county_47113: "Madison County",
	county_47115: "Marion County",
	county_47117: "Marshall County",
	county_47119: "Maury County",
	county_47121: "Meigs County",
	county_47123: "Monroe County",
	county_47125: "Montgomery County",
	county_47127: "Moore County",
	county_47129: "Morgan County",
	county_47131: "Obion County",
	county_47133: "Overton County",
	county_47135: "Perry County",
	county_47137: "Pickett County",
	county_47139: "Polk County",
	county_47141: "Putnam County",
	county_47143: "Rhea County",
	county_47145: "Roane County",
	county_47147: "Robertson County",
	county_47149: "Rutherford County",
	county_47151: "Scott County",
	county_47153: "Sequatchie County",
	county_47155: "Sevier County",
	county_47157: "Shelby County",
	county_47159: "Smith County",
	county_47161: "Stewart County",
	county_47163: "Sullivan County",
	county_47165: "Sumner County",
	county_47167: "Tipton County",
	county_47169: "Trousdale County",
	county_47171: "Unicoi County",
	county_47173: "Union County",
	county_47175: "Van Buren County",
	county_47177: "Warren County",
	county_47179: "Washington County",
	county_47181: "Wayne County",
	county_47183: "Weakley County",
	county_47185: "White County",
	county_47187: "Williamson County",
	county_47189: "Wilson County",
	county_48001: "Anderson County",
	county_48003: "Andrews County",
	county_48005: "Angelina County",
	county_48007: "Aransas County",
	county_48009: "Archer County",
	county_48011: "Armstrong County",
	county_48013: "Atascosa County",
	county_48015: "Austin County",
	county_48017: "Bailey County",
	county_48019: "Bandera County",
	county_48021: "Bastrop County",
	county_48023: "Baylor County",
	county_48025: "Bee County",
	county_48027: "Bell County",
	county_48029: "Bexar County",
	county_48031: "Blanco County",
	county_48033: "Borden County",
	county_48035: "Bosque County",
	county_48037: "Bowie County",
	county_48039: "Brazoria County",
	county_48041: "Brazos County",
	county_48043: "Brewster County",
	county_48045: "Briscoe County",
	county_48047: "Brooks County",
	county_48049: "Brown County",
	county_48051: "Burleson County",
	county_48053: "Burnet County",
	county_48055: "Caldwell County",
	county_48057: "Calhoun County",
	county_48059: "Callahan County",
	county_48061: "Cameron County",
	county_48063: "Camp County",
	county_48065: "Carson County",
	county_48067: "Cass County",
	county_48069: "Castro County",
	county_48071: "Chambers County",
	county_48073: "Cherokee County",
	county_48075: "Childress County",
	county_48077: "Clay County",
	county_48079: "Cochran County",
	county_48081: "Coke County",
	county_48083: "Coleman County",
	county_48085: "Collin County",
	county_48087: "Collingsworth County",
	county_48089: "Colorado County",
	county_48091: "Comal County",
	county_48093: "Comanche County",
	county_48095: "Concho County",
	county_48097: "Cooke County",
	county_48099: "Coryell County",
	county_48101: "Cottle County",
	county_48103: "Crane County",
	county_48105: "Crockett County",
	county_48107: "Crosby County",
	county_48109: "Culberson County",
	county_48111: "Dallam County",
	county_48113: "Dallas County",
	county_48115: "Dawson County",
	county_48117: "Deaf Smith County",
	county_48119: "Delta County",
	county_48121: "Denton County",
	county_48123: "DeWitt County",
	county_48125: "Dickens County",
	county_48127: "Dimmit County",
	county_48129: "Donley County",
	county_48131: "Duval County",
	county_48133: "Eastland County",
	county_48135: "Ector County",
	county_48137: "Edwards County",
	county_48139: "Ellis County",
	county_48141: "El Paso County",
	county_48143: "Erath County",
	county_48145: "Falls County",
	county_48147: "Fannin County",
	county_48149: "Fayette County",
	county_48151: "Fisher County",
	county_48153: "Floyd County",
	county_48155: "Foard County",
	county_48157: "Fort Bend County",
	county_48159: "Franklin County",
	county_48161: "Freestone County",
	county_48163: "Frio County",
	county_48165: "Gaines County",
	county_48167: "Galveston County",
	county_48169: "Garza County",
	county_48171: "Gillespie County",
	county_48173: "Glasscock County",
	county_48175: "Goliad County",
	county_48177: "Gonzales County",
	county_48179: "Gray County",
	county_48181: "Grayson County",
	county_48183: "Gregg County",
	county_48185: "Grimes County",
	county_48187: "Guadalupe County",
	county_48189: "Hale County",
	county_48191: "Hall County",
	county_48193: "Hamilton County",
	county_48195: "Hansford County",
	county_48197: "Hardeman County",
	county_48199: "Hardin County",
	county_48201: "Harris County",
	county_48203: "Harrison County",
	county_48205: "Hartley County",
	county_48207: "Haskell County",
	county_48209: "Hays County",
	county_48211: "Hemphill County",
	county_48213: "Henderson County",
	county_48215: "Hidalgo County",
	county_48217: "Hill County",
	county_48219: "Hockley County",
	county_48221: "Hood County",
	county_48223: "Hopkins County",
	county_48225: "Houston County",
	county_48227: "Howard County",
	county_48229: "Hudspeth County",
	county_48231: "Hunt County",
	county_48233: "Hutchinson County",
	county_48235: "Irion County",
	county_48237: "Jack County",
	county_48239: "Jackson County",
	county_48241: "Jasper County",
	county_48243: "Jeff Davis County",
	county_48245: "Jefferson County",
	county_48247: "Jim Hogg County",
	county_48249: "Jim Wells County",
	county_48251: "Johnson County",
	county_48253: "Jones County",
	county_48255: "Karnes County",
	county_48257: "Kaufman County",
	county_48259: "Kendall County",
	county_48261: "Kenedy County",
	county_48263: "Kent County",
	county_48265: "Kerr County",
	county_48267: "Kimble County",
	county_48269: "King County",
	county_48271: "Kinney County",
	county_48273: "Kleberg County",
	county_48275: "Knox County",
	county_48277: "Lamar County",
	county_48279: "Lamb County",
	county_48281: "Lampasas County",
	county_48283: "La Salle County",
	county_48285: "Lavaca County",
	county_48287: "Lee County",
	county_48289: "Leon County",
	county_48291: "Liberty County",
	county_48293: "Limestone County",
	county_48295: "Lipscomb County",
	county_48297: "Live Oak County",
	county_48299: "Llano County",
	county_48301: "Loving County",
	county_48303: "Lubbock County",
	county_48305: "Lynn County",
	county_48307: "McCulloch County",
	county_48309: "McLennan County",
	county_48311: "McMullen County",
	county_48313: "Madison County",
	county_48315: "Marion County",
	county_48317: "Martin County",
	county_48319: "Mason County",
	county_48321: "Matagorda County",
	county_48323: "Maverick County",
	county_48325: "Medina County",
	county_48327: "Menard County",
	county_48329: "Midland County",
	county_48331: "Milam County",
	county_48333: "Mills County",
	county_48335: "Mitchell County",
	county_48337: "Montague County",
	county_48339: "Montgomery County",
	county_48341: "Moore County",
	county_48343: "Morris County",
	county_48345: "Motley County",
	county_48347: "Nacogdoches County",
	county_48349: "Navarro County",
	county_48351: "Newton County",
	county_48353: "Nolan County",
	county_48355: "Nueces County",
	county_48357: "Ochiltree County",
	county_48359: "Oldham County",
	county_48361: "Orange County",
	county_48363: "Palo Pinto County",
	county_48365: "Panola County",
	county_48367: "Parker County",
	county_48369: "Parmer County",
	county_48371: "Pecos County",
	county_48373: "Polk County",
	county_48375: "Potter County",
	county_48377: "Presidio County",
	county_48379: "Rains County",
	county_48381: "Randall County",
	county_48383: "Reagan County",
	county_48385: "Real County",
	county_48387: "Red River County",
	county_48389: "Reeves County",
	county_48391: "Refugio County",
	county_48393: "Roberts County",
	county_48395: "Robertson County",
	county_48397: "Rockwall County",
	county_48399: "Runnels County",
	county_48401: "Rusk County",
	county_48403: "Sabine County",
	county_48405: "San Augustine County",
	county_48407: "San Jacinto County",
	county_48409: "San Patricio County",
	county_48411: "San Saba County",
	county_48413: "Schleicher County",
	county_48415: "Scurry County",
	county_48417: "Shackelford County",
	county_48419: "Shelby County",
	county_48421: "Sherman County",
	county_48423: "Smith County",
	county_48425: "Somervell County",
	county_48427: "Starr County",
	county_48429: "Stephens County",
	county_48431: "Sterling County",
	county_48433: "Stonewall County",
	county_48435: "Sutton County",
	county_48437: "Swisher County",
	county_48439: "Tarrant County",
	county_48441: "Taylor County",
	county_48443: "Terrell County",
	county_48445: "Terry County",
	county_48447: "Throckmorton County",
	county_48449: "Titus County",
	county_48451: "Tom Green County",
	county_48453: "Travis County",
	county_48455: "Trinity County",
	county_48457: "Tyler County",
	county_48459: "Upshur County",
	county_48461: "Upton County",
	county_48463: "Uvalde County",
	county_48465: "Val Verde County",
	county_48467: "Van Zandt County",
	county_48469: "Victoria County",
	county_48471: "Walker County",
	county_48473: "Waller County",
	county_48475: "Ward County",
	county_48477: "Washington County",
	county_48479: "Webb County",
	county_48481: "Wharton County",
	county_48483: "Wheeler County",
	county_48485: "Wichita County",
	county_48487: "Wilbarger County",
	county_48489: "Willacy County",
	county_48491: "Williamson County",
	county_48493: "Wilson County",
	county_48495: "Winkler County",
	county_48497: "Wise County",
	county_48499: "Wood County",
	county_48501: "Yoakum County",
	county_48503: "Young County",
	county_48505: "Zapata County",
	county_48507: "Zavala County",
	county_49001: "Beaver County",
	county_49003: "Box Elder County",
	county_49005: "Cache County",
	county_49007: "Carbon County",
	county_49009: "Daggett County",
	county_49011: "Davis County",
	county_49013: "Duchesne County",
	county_49015: "Emery County",
	county_49017: "Garfield County",
	county_49019: "Grand County",
	county_49021: "Iron County",
	county_49023: "Juab County",
	county_49025: "Kane County",
	county_49027: "Millard County",
	county_49029: "Morgan County",
	county_49031: "Piute County",
	county_49033: "Rich County",
	county_49035: "Salt Lake County",
	county_49037: "San Juan County",
	county_49039: "Sanpete County",
	county_49041: "Sevier County",
	county_49043: "Summit County",
	county_49045: "Tooele County",
	county_49047: "Uintah County",
	county_49049: "Utah County",
	county_49051: "Wasatch County",
	county_49053: "Washington County",
	county_49055: "Wayne County",
	county_49057: "Weber County",
	county_50001: "Addison County",
	county_50003: "Bennington County",
	county_50005: "Caledonia County",
	county_50007: "Chittenden County",
	county_50009: "Essex County",
	county_50011: "Franklin County",
	county_50013: "Grand Isle County",
	county_50015: "Lamoille County",
	county_50017: "Orange County",
	county_50019: "Orleans County",
	county_50021: "Rutland County",
	county_50023: "Washington County",
	county_50025: "Windham County",
	county_50027: "Windsor County",
	county_51001: "Accomack County",
	county_51003: "Albemarle-Charlottesville",
	county_51005: "Caledonia-Clifton Forge-Covington",
	county_51007: "Amelia County",
	county_51009: "Amherst County",
	county_51011: "Appomattox County",
	county_51013: "Arlington-Fairfax-Alexandria-Falls Church",
	county_51015: "Augusta-Staunton-Waynesboro",
	county_51017: "Bath County",
	county_51019: "Bedford-Lynchburg",
	county_51021: "Bland County",
	county_51023: "Botetourt County",
	county_51025: "Brunswick County",
	county_51027: "Buchanan County",
	county_51029: "Buckingham County",
	county_51033: "Caroline County",
	county_51035: "Carroll-Galax",
	county_51036: "Charles City County",
	county_51037: "Charlotte County",
	county_51041: "Chesterfield County",
	county_51043: "Clarke County",
	county_51045: "Craig County",
	county_51047: "Culpeper County",
	county_51049: "Cumberland County",
	county_51051: "Dickenson County",
	county_51053: "Dinwiddie-Prince George-Colonial Heights-Petersburg",
	county_51057: "Essex County",
	county_51061: "Fauquier County",
	county_51063: "Floyd County",
	county_51065: "Fluvanna County",
	county_51067: "Franklin County",
	county_51069: "Frederick-Winchester",
	county_51071: "Giles County",
	county_51073: "Gloucester County",
	county_51075: "Goochland County",
	county_51077: "Grayson County",
	county_51079: "Greene County",
	county_51081: "Greensville-Emporia",
	county_51083: "Halifax County",
	county_51085: "Hanover County",
	county_51087: "Henrico County",
	county_51089: "Henry-Martinsville",
	county_51091: "Highland County",
	county_51093: "Isle of Wight County",
	county_51095: "James City-York-Newport News-Poquoson-Williamsburg",
	county_51097: "King and Queen County",
	county_51099: "King George County",
	county_51101: "King William County",
	county_51103: "Lancaster County",
	county_51105: "Lee County",
	county_51107: "Loudoun County",
	county_51109: "Louisa County",
	county_51111: "Lunenburg County",
	county_51113: "Madison County",
	county_51115: "Mathews County",
	county_51117: "Mecklenburg County",
	county_51119: "Middlesex County",
	county_51121: "Montgomery-Radford",
	county_51123: "Suffolk city",
	county_51125: "Nelson County",
	county_51127: "New Kent County",
	county_51131: "Northampton County",
	county_51133: "Northumberland County",
	county_51135: "Nottoway County",
	county_51137: "Orange County",
	county_51139: "Page County",
	county_51141: "Patrick County",
	county_51143: "Pittsylvania-Danville",
	county_51145: "Powhatan County",
	county_51147: "Prince Edward County",
	county_51153: "Prince William-Manassas-Manassas Park",
	county_51155: "Pulaski County",
	county_51157: "Rappahannock County",
	county_51159: "Richmond County",
	county_51161: "Roanoke-Roanoke-Salem",
	county_51163: "Rockbridge-Buena Vista-Lexington",
	county_51165: "Rockingham-Harrisonburg",
	county_51167: "Russell County",
	county_51169: "Scott County",
	county_51171: "Shenandoah County",
	county_51173: "Smyth County",
	county_51175: "Southampton-Franklin",
	county_51177: "Spotsylvania-Stafford-Fredericksburg",
	county_51181: "Surry County",
	county_51183: "Sussex County",
	county_51185: "Tazewell County",
	county_51187: "Warren County",
	county_51191: "Washington-Bristol",
	// county_51191: "Wise-Norton",
	county_51193: "Westmoreland County",
	county_51195: "Wise County",
	county_51197: "Wythe County",
	county_51550: "Chesapeake city",
	county_51650: "Hampton city",
	county_51710: "Norfolk city",
	county_51740: "Portsmouth city",
	county_51760: "Richmond city",
	county_51810: "Virginia Beach city",
	county_53001: "Adams County",
	county_53003: "Asotin County",
	county_53005: "Benton County",
	county_53007: "Chelan County",
	county_53009: "Clallam County",
	county_53011: "Clark County",
	county_53013: "Columbia County",
	county_53015: "Cowlitz County",
	county_53017: "Douglas County",
	county_53019: "Ferry County",
	county_53021: "Franklin County",
	county_53023: "Garfield County",
	county_53025: "Grant County",
	county_53027: "Grays Harbor County",
	county_53029: "Island County",
	county_53031: "Jefferson County",
	county_53033: "King County",
	county_53035: "Kitsap County",
	county_53037: "Kittitas County",
	county_53039: "Klickitat County",
	county_53041: "Lewis County",
	county_53043: "Lincoln County",
	county_53045: "Mason County",
	county_53047: "Okanogan County",
	county_53049: "Pacific County",
	county_53051: "Pend Oreille County",
	county_53053: "Pierce County",
	county_53055: "San Juan County",
	county_53057: "Skagit County",
	county_53059: "Skamania County",
	county_53061: "Snohomish County",
	county_53063: "Spokane County",
	county_53065: "Stevens County",
	county_53067: "Thurston County",
	county_53069: "Wahkiakum County",
	county_53071: "Walla Walla County",
	county_53073: "Whatcom County",
	county_53075: "Whitman County",
	county_53077: "Yakima County",
	county_54001: "Barbour County",
	county_54003: "Berkeley County",
	county_54005: "Boone County",
	county_54007: "Braxton County",
	county_54009: "Brooke County",
	county_54011: "Cabell County",
	county_54013: "Calhoun County",
	county_54015: "Clay County",
	county_54017: "Doddridge County",
	county_54019: "Fayette County",
	county_54021: "Gilmer County",
	county_54023: "Grant County",
	county_54025: "Greenbrier County",
	county_54027: "Hampshire County",
	county_54029: "Hancock County",
	county_54031: "Hardy County",
	county_54033: "Harrison County",
	county_54035: "Jackson County",
	county_54037: "Jefferson County",
	county_54039: "Kanawha County",
	county_54041: "Lewis County",
	county_54043: "Lincoln County",
	county_54045: "Logan County",
	county_54047: "McDowell County",
	county_54049: "Marion County",
	county_54051: "Marshall County",
	county_54053: "Mason County",
	county_54055: "Mercer County",
	county_54057: "Mineral County",
	county_54059: "Mingo County",
	county_54061: "Monongalia County",
	county_54063: "Monroe County",
	county_54065: "Morgan County",
	county_54067: "Nicholas County",
	county_54069: "Ohio County",
	county_54071: "Pendleton County",
	county_54073: "Pleasants County",
	county_54075: "Pocahontas County",
	county_54077: "Preston County",
	county_54079: "Putnam County",
	county_54081: "Raleigh County",
	county_54083: "Randolph County",
	county_54085: "Ritchie County",
	county_54087: "Roane County",
	county_54089: "Summers County",
	county_54091: "Taylor County",
	county_54093: "Tucker County",
	county_54095: "Tyler County",
	county_54097: "Upshur County",
	county_54099: "Wayne County",
	county_54101: "Webster County",
	county_54103: "Wetzel County",
	county_54105: "Wirt County",
	county_54107: "Wood County",
	county_54109: "Wyoming County",
	county_55001: "Adams County",
	county_55003: "Ashland County",
	county_55005: "Barron County",
	county_55007: "Bayfield County",
	county_55009: "Brown County",
	county_55011: "Buffalo County",
	county_55013: "Burnett County",
	county_55015: "Calumet County",
	county_55017: "Chippewa County",
	county_55019: "Clark County",
	county_55021: "Columbia County",
	county_55023: "Crawford County",
	county_55025: "Dane County",
	county_55027: "Dodge County",
	county_55029: "Door County",
	county_55031: "Douglas County",
	county_55033: "Dunn County",
	county_55035: "Eau Claire County",
	county_55037: "Florence County",
	county_55039: "Fond du Lac County",
	county_55041: "Forest County",
	county_55043: "Grant County",
	county_55045: "Green County",
	county_55047: "Green Lake County",
	county_55049: "Iowa County",
	county_55051: "Iron County",
	county_55053: "Jackson County",
	county_55055: "Jefferson County",
	county_55057: "Juneau County",
	county_55059: "Kenosha County",
	county_55061: "Kewaunee County",
	county_55063: "La Crosse County",
	county_55065: "Lafayette County",
	county_55067: "Langlade County",
	county_55069: "Lincoln County",
	county_55071: "Manitowoc County",
	county_55073: "Marathon County",
	county_55075: "Marinette County",
	county_55077: "Marquette County",
	county_55078: "Menominee-Shawano Counties",
	county_55079: "Milwaukee County",
	county_55081: "Monroe County",
	county_55083: "Oconto County",
	county_55085: "Oneida County",
	county_55087: "Outagamie County",
	county_55089: "Ozaukee County",
	county_55091: "Pepin County",
	county_55093: "Pierce County",
	county_55095: "Polk County",
	county_55097: "Portage County",
	county_55099: "Price County",
	county_55101: "Racine County",
	county_55103: "Richland County",
	county_55105: "Rock County",
	county_55107: "Rusk County",
	county_55109: "St. Croix County",
	county_55111: "Sauk County",
	county_55113: "Sawyer County",
	county_55117: "Sheboygan County",
	county_55119: "Taylor County",
	county_55121: "Trempealeau County",
	county_55123: "Vernon County",
	county_55125: "Vilas County",
	county_55127: "Walworth County",
	county_55129: "Washburn County",
	county_55131: "Washington County",
	county_55133: "Waukesha County",
	county_55135: "Waupaca County",
	county_55137: "Waushara County",
	county_55139: "Winnebago County",
	county_55141: "Wood County",
	county_56001: "Albany County",
	county_56003: "Big Horn County",
	county_56005: "Campbell County",
	county_56007: "Carbon County",
	county_56009: "Converse County",
	county_56011: "Crook County",
	county_56013: "Fremont County",
	county_56015: "Goshen County",
	county_56017: "Hot Springs County",
	county_56019: "Johnson County",
	county_56021: "Laramie County",
	county_56023: "Lincoln County",
	county_56025: "Natrona County",
	county_56027: "Niobrara County",
	county_56029: "Park County",
	county_56031: "Platte County",
	county_56033: "Sheridan County",
	county_56035: "Sublette County",
	county_56037: "Sweetwater County",
	county_56039: "Teton County",
	county_56041: "Uinta County",
	county_56043: "Washakie County",
	county_56045: "Weston County",
};